import * as React from "react";

const SvgWeiterhelfen = React.forwardRef((props, ref) => {
  return (
    <svg
      id="weiterhelfen_svg__Ebene_1"
      data-name="Ebene 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 2350"
      {...props}
			ref={ref}
    >
      <defs>
        <clipPath id="weiterhelfen_svg__clip-path">
          <path
            className="weiterhelfen_svg__cls-2"
            d="M-.28-4.48h1920v2504.76H-.28z"
          />
        </clipPath>
        <clipPath id="weiterhelfen_svg__clip-path-2">
          <path
            className="weiterhelfen_svg__cls-2"
            d="M1504 157l-318.79 271.63 24 153.78s-1.28 3.4 1.43 4.29 9.2 3.13 28.58-.18c0 0-23 8.4-22.06 14.65s17.59 4.28 27.42 2.05.89.62.89.62-15.75 7.95-13.4 13c2.24 4.82 14.83 2.14 14.83 2.14s29-6.69 48.67-15.09c0 0 70.73-3.48 80.87-5.26v112.2s-1 39.29 28.43 71c0 0 12.51 12.5 15.19 14.28s-7.67 6.7-7.67 6.7l28.43 27.68 309.21 7 117.21-167.77-14.51-279.07-102.7-243.35z"
          />
        </clipPath>
        <clipPath id="weiterhelfen_svg__clip-path-3">
          <path
            className="weiterhelfen_svg__cls-2"
            d="M1539.55 210.63h106.32v105.45h-106.32z"
          />
        </clipPath>
        <clipPath id="weiterhelfen_svg__clip-path-5">
          <path
            className="weiterhelfen_svg__cls-2"
            d="M1639.13 184.24h68.9v68.82h-68.9z"
          />
        </clipPath>
        <clipPath id="weiterhelfen_svg__clip-path-7">
          <path
            className="weiterhelfen_svg__cls-2"
            d="M63.46 197.52L43.74 449.71v130l68.17 182.25h432.62a144 144 0 0053.41-111.75V486.68l88-102.82-9.64-193.68L535.54 15.61z"
          />
        </clipPath>
        <clipPath id="weiterhelfen_svg__clip-path-8">
          <path
            className="weiterhelfen_svg__cls-2"
            d="M513.03 52.49h40.33v65.04h-40.33z"
          />
        </clipPath>
        <clipPath id="weiterhelfen_svg__clip-path-10">
          <path
            className="weiterhelfen_svg__cls-2"
            d="M291.27 244.86v301.65l28.64-301.65h-28.64z"
          />
        </clipPath>
        <clipPath id="weiterhelfen_svg__clip-path-12" />
        <clipPath id="weiterhelfen_svg__clip-path-13">
          <path
            className="weiterhelfen_svg__cls-2"
            d="M447.72 220.75v312.68l27.97-312.68h-27.97z"
          />
        </clipPath>
        <clipPath id="weiterhelfen_svg__clip-path-15">
          <path
            className="weiterhelfen_svg__cls-2"
            d="M126.51 289.01h438.54v21.37H126.51z"
          />
        </clipPath>
        <clipPath id="weiterhelfen_svg__clip-path-17">
          <path
            className="weiterhelfen_svg__cls-2"
            d="M133.47 336.93h431.58v18.26H133.47z"
          />
        </clipPath>
        <clipPath id="weiterhelfen_svg__clip-path-19">
          <path
            className="weiterhelfen_svg__cls-2"
            d="M305.77 147.71h71.32v30.85h-71.32z"
          />
        </clipPath>
        <clipPath id="weiterhelfen_svg__clip-path-21">
          <path className="weiterhelfen_svg__cls-2" d="M347.65 234.89z" />
        </clipPath>
        <clipPath id="weiterhelfen_svg__clip-path-22">
          <path
            className="weiterhelfen_svg__cls-2"
            d="M369.74 2269.56h71.27v52.81h-71.27z"
          />
        </clipPath>
        <clipPath id="weiterhelfen_svg__clip-path-23">
          <path
            className="weiterhelfen_svg__cls-2"
            d="M221.09 2270.3l11.84 68.88 4.56 24.11s2.36 6.7 5.93 8.93 5.8 3.58 15.63 2.24 102-18.53 102-18.53l8.09 11.47s3.93 7 10.18 4.29 6.87-5.27 6.87-5.27 4.74 2 8.22-.36a10.13 10.13 0 004.2-5.8l1.6-.9s4.47 2.64 8.22.18a9.5 9.5 0 004.29-5.89l1-.54s4.51.63 6.84-1.34 2.87-7.23 2.87-7.23l131.1-24.11-22.68-93.59z"
          />
        </clipPath>
        <linearGradient
          id="weiterhelfen_svg__Unbenannter_Verlauf"
          x1={-1.65}
          y1={2337.74}
          x2={-0.65}
          y2={2337.74}
          gradientTransform="matrix(0 -54.93 -54.93 0 129375.93 2097.4)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={1} />
        </linearGradient>
        <filter
          id="weiterhelfen_svg__luminosity-noclip"
          x={-509.67}
          y={-394.95}
          width={2938.78}
          height={3285.69}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodColor="#fff" result="bg" />
          <feBlend in="SourceGraphic" in2="bg" />
        </filter>
        <style>
          {
            ".weiterhelfen_svg__cls-2{fill:none}.weiterhelfen_svg__cls-63{fill:#9454ff}.weiterhelfen_svg__cls-64{clip-path:url(#weiterhelfen_svg__clip-path-2)}.weiterhelfen_svg__cls-65{fill:#b5ccfc}.weiterhelfen_svg__cls-67{fill:#21211c}.weiterhelfen_svg__cls-68{fill:#fff}.weiterhelfen_svg__cls-69{fill:#f0b5ab}.weiterhelfen_svg__cls-72{fill:#99734f}.weiterhelfen_svg__cls-73{fill:#edc729}.weiterhelfen_svg__cls-74{fill:#f52629}.weiterhelfen_svg__cls-75{fill:#e83317}.weiterhelfen_svg__cls-76{clip-path:url(#weiterhelfen_svg__clip-path-7)}.weiterhelfen_svg__cls-77{fill:#2e4d9e}.weiterhelfen_svg__cls-79{fill:#1d1d1b}.weiterhelfen_svg__cls-81{fill:#ffdeba}.weiterhelfen_svg__cls-82{fill:#dee8ff}.weiterhelfen_svg__cls-90{fill:#d6962e}.weiterhelfen_svg__cls-93{fill:#fa8ade}.weiterhelfen_svg__cls-94{fill:#de8857}.weiterhelfen_svg__cls-95{fill:#24bacc}.weiterhelfen_svg__cls-96{fill:#ede557}.weiterhelfen_svg__cls-97{fill:#fac4ab}.weiterhelfen_svg__cls-99{fill:#f7ba99}.weiterhelfen_svg__cls-102{fill:#f74aad}.weiterhelfen_svg__cls-104{fill:#ff0001}.weiterhelfen_svg__cls-106{fill:#fcd400}"
          }
        </style>
        <mask
          id="weiterhelfen_svg__mask"
          x={-509.67}
          y={-394.95}
          width={2938.78}
          height={3285.69}
          maskUnits="userSpaceOnUse"
        >
          <g filter="url(#weiterhelfen_svg__luminosity-noclip)">
            <path
              transform="rotate(-12 959.737 1247.898)"
              fill="url(#weiterhelfen_svg__Unbenannter_Verlauf)"
              d="M-239.68-176.71h2398.81V2672.5H-239.68z"
            />
          </g>
        </mask>
      </defs>
      <g
        clipPath="url(#weiterhelfen_svg__clip-path)"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="#fcd15e"
        strokeWidth={9.45}
        fill="none"
        id="weiterhelfen_svg__dotted-line"
      >
        <path
          d="M528.9 238.6c58.1-1.48 116.19-8.6 173.94-14.26"
          strokeDasharray="0 26.86"
          opacity={0}
        />
        <path
          d="M742.86 220.31c66.33-7.44 133-19.82 195.2-45.22"
          strokeDasharray="0 26.8"
          opacity={0}
        />
        <path
          d="M976.13 155.64c17.4-12 33.45-29.26 46.56-55.95"
          strokeDasharray="0 29.44"
          opacity={0}
        />
        <path
          d="M1022.38 60.52c-8.51-9.82-22.61-17.75-35.49-21.45"
          strokeDasharray="0 27.99"
          opacity={0}
        />
        <path
          d="M940.63 46.52a49.77 49.77 0 00-11.93 12.34"
          strokeDasharray="0 34.49"
          opacity={0}
        />
        <path
          d="M923 100.11c4.56 11.86 13.43 23.13 22.28 32.25"
          strokeDasharray="0 26.31"
          opacity={0}
        />
        <path
          d="M975.71 156c3.69 2.13 7.45 4.18 11.17 6.2"
          strokeDasharray="0 25.55"
          opacity={0}
        />
        <path
          d="M1023 184.11c12.29 8.24 24.51 16.65 37.53 23.5"
          strokeDasharray="0 29.54"
          opacity={0}
        />
        <path
          d="M1100.1 223c13.31 3.89 27 7.06 40.37 10"
          strokeDasharray="0 27.72"
          opacity={0}
        />
        <path
          d="M1182.53 240.82c33.49 4.71 67.24 6.2 100.57 12.05"
          strokeDasharray="0 28.95"
          opacity={0}
        />
        <path
          d="M1323.44 262.14c55.92 15.5 109.92 40.33 163.29 62.74"
          strokeDasharray="0 26.93"
          opacity={0}
        />
        <path
          d="M1523.4 340.84c43.76 21 85.24 50 112.52 90.23"
          strokeDasharray="0 26.53"
          opacity={0}
        />
        <path
          d="M1654.57 467.23c10.92 29.9 13.81 63.22 14 94.83"
          strokeDasharray="0 27.52"
          opacity={0}
        />
        <path
          d="M1666.52 603.25c-3.88 32.06-13.22 62.24-25.41 92.58"
          strokeDasharray="0 27.51"
          opacity={0}
        />
        <path
          d="M1623.46 736.13c-23.46 49.35-54.45 99.24-94.59 135.6"
          strokeDasharray="0 30.25"
          opacity={0}
        />
        <path
          d="M1495.37 898.46c-3.58 2.83-7.1 5.77-10.56 9"
          strokeDasharray="0 27.74"
          opacity={0}
        />
        <path
          d="M1457.16 941.53c-29.92 46.27-42.8 102.45-48.18 156.92"
          strokeDasharray="0 30.13"
          opacity={0}
        />
        <path
          d="M1406.24 1141.16c-1.4 50.88 4.23 102 20.53 150.38"
          strokeDasharray="0 27.74"
          opacity={0}
        />
        <path
          d="M1442.3 1330c22.68 47.29 57.66 87.43 113.23 87.73"
          strokeDasharray="0 27.59"
          opacity={0}
        />
        <path
          d="M1592.27 1411.29c4.15-1.91 7.47-4.23 9.48-7"
          strokeDasharray="0 23.76"
          opacity={0}
        />
        <path
          d="M1580.54 1379.38c-12.84-2.63-28.46-1.82-40.23 1"
          strokeDasharray="0 27.02"
          opacity={0}
        />
        <path
          d="M1515.26 1408.67c1.63 19.68 21.37 43.89 36.43 59.37"
          strokeDasharray="0 28.32"
          opacity={0}
        />
        <path
          d="M1584.92 1496.79c30.07 21.71 59.7 31.27 97.52 32.13"
          strokeDasharray="0 29.84"
          opacity={0}
        />
        <path
          d="M1711.56 1508.71a22.19 22.19 0 00-8.78-10.85"
          strokeDasharray="0 28.4"
          opacity={0}
        />
        <path
          d="M1662.93 1485.74a224.62 224.62 0 00-41.09-4.86"
          strokeDasharray="0 27.63"
          opacity={0}
        />
        <path
          d="M1580.76 1482.3c-32.16 3.26-62.18 12.74-88.67 32.46"
          strokeDasharray="0 27.32"
          opacity={0}
        />
        <path
          d="M1461 1545.26c-21.51 27.45-34.88 61.12-43.48 94.94"
          strokeDasharray="0 30.05"
          opacity={0}
        />
        <path
          d="M1409.25 1680.74a248.22 248.22 0 00.17 65.74"
          strokeDasharray="0 26.37"
          opacity={0}
        />
        <path
          d="M1418.14 1787.24a446.61 446.61 0 0050.8 117.4"
          strokeDasharray="0 28.52"
          opacity={0}
        />
        <path
          d="M1491.57 1942.21c27.46 45.4 60.11 96.6 56.65 149.86"
          strokeDasharray="0 29.6"
          opacity={0}
        />
        <path
          d="M1538.26 2131.34A108.68 108.68 0 011516 2163"
          strokeDasharray="0 25.94"
          opacity={0}
        />
        <path
          d="M1482.74 2191.84a429 429 0 01-64.69 42.75"
          strokeDasharray="0 31.06"
          opacity={0}
        />
        <path
          d="M1376.81 2253.55a313.43 313.43 0 01-72.41 17.8"
          strokeDasharray="0 29.9"
          opacity={0}
        />
        <path
          d="M1260.82 2276.4a226 226 0 01-99.2-15.86"
          strokeDasharray="0 28.94"
          opacity={0}
        />
        <path
          d="M1126.87 2236.31q-35.71-35.36-49.29-84.82"
          strokeDasharray="0 28.36"
          opacity={0}
        />
        <path
          d="M1086.21 2111.38c2.57-4.14 5.13-8.29 7.25-12.59"
          strokeDasharray="0 29.08"
          opacity={0}
        />
        <path
          d="M1110.44 2061.8c6.73-12.26 13.85-22.56 25.56-29.44"
          strokeDasharray="0 26.33"
          opacity={0}
        />
        <path
          d="M1172.94 2032.13c4 2.24 7.18 5.22 8.87 9"
          strokeDasharray="0 25.75"
          opacity={0}
        />
        <path
          d="M1165.38 2078.54c-10.79 10.37-24.78 19-37.68 24.81"
          strokeDasharray="0 30.21"
          opacity={0}
        />
        <path
          d="M1085.76 2111.87a686 686 0 01-70 2.83"
          strokeDasharray="0 28.02"
          opacity={0}
        />
        <path
          d="M970.11 2114.52q-39.6-.42-79.11-3.5"
          strokeDasharray="0 31.68"
          opacity={0}
        />
        <path
          d="M849.28 2106.12a729 729 0 01-89.42-19.72"
          strokeDasharray="0 26.18"
          opacity={0}
        />
        <path
          d="M721 2075.12c-65.73-19.49-130.12-43.5-190.66-75.86"
          strokeDasharray="0 27.41"
          opacity={0}
        />
        <path
          d="M494.56 1978.76c-67-41.38-123.74-93.29-181.17-147.21"
          strokeDasharray="0 27.51"
          opacity={0}
        />
        <path
          d="M280.5 1801.73a672.9 672.9 0 01-52.89-55.36"
          strokeDasharray="0 30.64"
          opacity={0}
        />
        <path
          d="M203.11 1708.14a174.41 174.41 0 01-13.11-43.37"
          strokeDasharray="0 30.29"
          opacity={0}
        />
        <path
          d="M186.45 1620.93c.05-43.72 11.85-85.42 29.79-125.51"
          strokeDasharray="0 28.88"
          opacity={0}
        />
        <path
          d="M234.57 1458.4a631.35 631.35 0 0134.93-57.4"
          strokeDasharray="0 26.88"
          opacity={0}
        />
        <path
          d="M289.27 1369.67c5.2-9.33 10.89-19.76 17.72-30.75"
          strokeDasharray="0 23.66"
          opacity={0}
        />
        <path
          d="M325.37 1304.48c13.38-43.89-3.27-102.88-29.61-143.52"
          strokeDasharray="0 27.4"
          opacity={0}
        />
        <path
          d="M266.36 1134.27c-54.48-32.74-55.13 24.65-31.45 67.5"
          strokeDasharray="0 26.55"
          opacity={0}
        />
        <path
          d="M257.44 1237.56c26.18 36.66 76.47 76.39 192.87-.21"
          strokeDasharray="0 29.04"
          opacity={0}
        />
        <path
          d="M473.51 1208.7a31.72 31.72 0 00-.53-11.8"
          strokeDasharray="0 23.76"
          opacity={0}
        />
        <path
          d="M449.89 1149.66q4.71 9.06 9.43 18.09"
          strokeDasharray="0 40.79"
          opacity={0}
        />
        <path
          d="M435.91 1127.91a594.26 594.26 0 00-56.08-70.91"
          strokeDasharray="0 25.86"
          opacity={0}
        />
        <path
          d="M349.29 1025.16q-27.07-28-54.13-56"
          strokeDasharray="0 31.17"
          opacity={0}
        />
        <path
          d="M267.51 938.66c-19.41-23-36.93-47.92-42.24-77.68"
          strokeDasharray="0 25.57"
          opacity={0}
        />
        <path
          d="M225.36 823.48c3.74-20.49 13.37-39.37 27-55.35"
          strokeDasharray="0 24.93"
          opacity={0}
        />
        <path
          d="M260.93 759.05h0m9.8-20.53h0m1.08-24.77h0M267.5 689h0m-8.61-24.76h0m-5.38-24.76h0m2.15-26.91h0m7.53-22.57h0m14-21.53h0M290.11 549h0m14-17.23h0m15.08-17.22h0m17.22-17.23h0M352.55 478h0m2.15-21.53h0m-9.7-19.4h0m-8.61-21.53h0m-4.3-22.61h0m-1.09-22.6h0m4.31-22.61h0m8.61-21.53h0M355.78 309h0M373 292.81h0m20.45-15.07h0m20.46-11.84h0m25.83-11.85h0m29.07-8.61h0M223.8 848.3h0m60.55 109.6h0m86.65 89.66h0m78.92 102.1h0m18.86 36.17h0m-6.43 43.37h0M242 1213h0m45.94-63.26h0M313.4 1329h0m-36.2 61h0m-54.87 92.32h0m-34.19 167.4h0m29.67 84.85h0m85.56 87.54h0m214.91 170.56h0m229 90h0m127.9 27h0m126.59 4.74h0m111.8-5.66h0m68.49-55h0m-34-26.63h0m-49.9 58h0m-23.85 52.63h0m74 117.09h0m141.19 18.05h0m114.72-31.13h0m102-70.1h0m40-64.87h0m-69.74-190.07h0m-65.08-157.18h0m2.53-104.66h0m67.45-131.46h0m126.62-42.49h0m81.51 12.17h0m7.82 35.74h0m-135.51-50.94h0m-34.16-92.84h0m75 8h0M1569.3 1417h0m-137.84-112.38h0m-23.79-191.13h0m67.51-196.05h0m42.19-35.85h0m118.48-173h0m32.57-132.72h0M1643 442.3h0m-143.84-112.24h0m-201.85-74.41h0M1154 235.84h0m-80.11-22h0m-75.84-45.57h0m-43.32-26.89h0M921.3 74.37h0m51.82-37.55h0m55.58 49.43h0m-78.3 83.61h0m-234.2 53.19h0m-214.15 15.82h0"
          opacity={0}
        />
      </g>
      <g id="weiterhelfen_svg__woman-top-right">
        <path
          className="weiterhelfen_svg__cls-63"
          d="M1897.28 546.17H1809c-10-50.09-54.35-88.15-107.2-88.15h-216.1c-60.1 0-109.28 49.23-109.28 109.4V708c0 60.17 49.18 109.4 109.28 109.4h216.1c60.11 0 109.29-49.23 109.29-109.4v-97.89z"
        />
        <g className="weiterhelfen_svg__cls-64">
          <path
            className="weiterhelfen_svg__cls-65"
            d="M1448.16 645.21h146.82v-110.8h-131.35l-7.4 31.59-8.07 79.21z"
          />
          <path
            className="weiterhelfen_svg__cls-65"
            d="M1017.56 789.93l608.77-13.16V640.76l-608.77-17.49v166.66z"
          />
          <path
            d="M1017.56 623.27l98 2.81-50.59 23.59 68.79 137.75-116.17 2.51zm347.85 43.22A23.22 23.22 0 011376 669l184 94.34a112.48 112.48 0 0052.77 13.24 111.07 111.07 0 0013.63-.84v1l-467.17 10.1 194.3-117.06a23.13 23.13 0 0112-3.32"
            fill="#9cadd4"
          />
          <path
            className="weiterhelfen_svg__cls-67"
            d="M1241.89 714.9h257.35a1.09 1.09 0 100-2.17h-257.35a1.09 1.09 0 100 2.17"
          />
          <path
            className="weiterhelfen_svg__cls-65"
            d="M1064.94 649.67l74.46 149.11 214.06-129A23.18 23.18 0 011376 669l184 94.34a112.61 112.61 0 00165.33-99.51V527.65l-157.34 6.76 13.81 87.29-105.24-54-46.41-23.7a151.58 151.58 0 00-133.21-2.48z"
          />
          <path
            className="weiterhelfen_svg__cls-67"
            d="M1125.74 713.67a1 1 0 00.53-.14L1320.42 603a78.4 78.4 0 0167.58-5l217.7 87.83a41.63 41.63 0 0056.49-46.3L1645.92 553a1.08 1.08 0 10-2.13.4l16.28 86.6a39.47 39.47 0 01-53.55 43.89L1388.81 596a80.58 80.58 0 00-69.47 5.06L1125.2 711.64a1.09 1.09 0 00.54 2"
          />
          <path
            className="weiterhelfen_svg__cls-67"
            d="M1570.33 604.54a1.1 1.1 0 001-.7 1.09 1.09 0 00-.63-1.4l-100.2-38.15a1.09 1.09 0 00-.77 2l100.19 38.15a1.07 1.07 0 00.39.07"
          />
          <path
            className="weiterhelfen_svg__cls-68"
            d="M1463.56 540.96h273.88v28.91h-273.88z"
          />
          <path
            className="weiterhelfen_svg__cls-69"
            d="M1289.91 587.67s-62 17.5-57.62 29.34c3.89 10.53 68.55-14.61 68.55-14.61z"
          />
          <path
            className="weiterhelfen_svg__cls-69"
            d="M1278 575.19s-63.63 15.24-60.77 26.57 67.81-8.18 67.81-8.18z"
          />
          <path
            className="weiterhelfen_svg__cls-69"
            d="M1273.49 559.24s-66.83 13.72-64.39 25.32c2.39 11.29 70.44-6.58 70.44-6.58z"
          />
          <path
            className="weiterhelfen_svg__cls-69"
            d="M1284.66 541.75s-77 11-75 22.65c2.12 12.72 67.7-1.66 67.7-1.66z"
          />
          <path
            className="weiterhelfen_svg__cls-69"
            d="M1311.44 540.38s-73-25.93-76.54-13.72c-4.79 16.8 57.52 31.18 57.52 31.18z"
          />
          <path
            className="weiterhelfen_svg__cls-69"
            d="M1642 358.76c-8.67-2.54-17.37-5-26.06-7.42l-26.12-7.18-13.07-3.53-1.64-.44-.58-.16c-.71-.18-1.41-.35-2.12-.51-1.41-.32-2.85-.57-4.3-.76a49.91 49.91 0 00-46.28 19.34c-.88 1.17-1.7 2.38-2.49 3.6l-.48.79-.41.71-.81 1.44s-.23.43-.09.18l.4-.72-.09.16-.2.34-.39.71-1.61 2.85-3.28 5.76-6.61 11.53q-13.29 23.08-27.08 45.76c-9.2 15.07-18.57 30-28.17 44.26-4.79 7.14-9.65 14.12-14.52 20.7-2.42 3.28-4.86 6.45-7.23 9.38s-4.69 5.63-6.6 7.64c-.9.94-1.81 1.83-2.07 2.06l-.08.08h.07l.27-.19.31-.17.69-.41.37-.18.27-.13a11.82 11.82 0 01-2 .86c-1.15.43-2.61.9-4.23 1.37-3.19.94-6.92 1.85-10.74 2.7s-7.88 1.63-12 2.37c-8.19 1.49-16.68 2.78-25.25 4s-17.25 2.3-26 3.31-17.5 1.94-26.29 2.79l-13.18 1.22-13 1.09h-.56a35.3 35.3 0 004.45 70.45l7.08-.31 6.94-.33 13.84-.77q13.82-.81 27.69-1.89c18.54-1.45 37.07-3.23 56.29-6.07 4.82-.72 9.7-1.52 14.69-2.44s10.12-2 15.64-3.41c2.75-.7 5.63-1.51 8.75-2.53a91.56 91.56 0 0010.6-4.13 60.5 60.5 0 007.56-4.25l1.69-1.14 1.4-1c.91-.67 1.89-1.41 2.61-2 3.25-2.61 5.61-4.85 7.91-7.08 4.46-4.4 8.09-8.47 11.53-12.48s6.56-7.93 9.6-11.84c6.06-7.81 11.69-15.53 17.14-23.26 10.9-15.46 21.11-30.92 31.1-46.46s19.66-31.13 29.19-46.84c2.38-3.92 4.76-7.86 7.1-11.82l3.53-6 1.77-3 .45-.77.22-.39.12-.2.51-.91v-.07.06c-.13.24-.26.47-.4.7l-.47.77a24 24 0 01-1.52 2.21 30.56 30.56 0 01-28.38 11.89c-.89-.12-1.77-.28-2.63-.46-.44-.1-.87-.2-1.29-.32h-.08.1l.21.06 1.63.46 13 3.62 26.14 7.13c8.72 2.32 17.44 4.67 26.19 6.91a40.06 40.06 0 0021.35-77.29"
          />
          <path
            className="weiterhelfen_svg__cls-68"
            d="M1676.81 374.5l55.8 178.5h-243.5l57.66-178.16c7.46-22.51 34.3-38.3 65.08-38.3 30.6 0 57.33 15.61 65 37.94M1813.4299999999998 667.22zm-35.35 35.4"
          />
          <path
            className="weiterhelfen_svg__cls-69"
            d="M1657.22 324.91h.3a49.8 49.8 0 0145.15 28.92l-.28-.47c-.56-.95-.93-1.59-1.85-3.06l4.47 9.56a52.14 52.14 0 00-2.34-6l1.2 2.07c.94 1.65 1.87 3.29 2.75 4.89 1.78 3.22 3.46 6.38 5.11 9.56 3.28 6.33 6.37 12.62 9.37 18.92 6 12.6 11.61 25.2 16.94 37.85s10.39 25.35 15.23 38.08 9.52 25.5 13.9 38.34c8.86 25.64 16.92 51.44 24.49 77.33s14.36 51.94 20.76 78a35.37 35.37 0 011 8.31v.1a35.33 35.33 0 01-35.28 35.3h-.07a35.3 35.3 0 01-33.89-25.6q-9-31.34-18.92-62.27v-44.87h12.18V541h-8.6l-3.58-11.45v-1.86h-.57l-47.88-153.19c-5.94-17.37-23.44-30.68-45.32-35.73l-.6-10.12c3.77-.65 7.53-1.3 11.31-1.91l5.12-.85 1.28-.22 1.51-.23c1.1-.16 2.21-.29 3.32-.38s2.52-.15 3.79-.15"
          />
          <path
            className="weiterhelfen_svg__cls-69"
            d="M1725.26 527.65v1.86l-.57-1.83zm-15 42.22h15v44.86q-2-6.09-4-12.16-5.37-16.41-11-32.7"
          />
          <path
            className="weiterhelfen_svg__cls-69"
            d="M1728.84 541h8.6v28.91h-27.18q-2.94-8.45-6-16.85h28.33zM1572.08 340.19l-.49 4.12c-.1.83-.16 1.66-.19 2.48-10.18 5.79-18.16 13.77-22.65 23.17a40.11 40.11 0 0123.33-29.77"
          />
          <path
            className="weiterhelfen_svg__cls-69"
            d="M1631.49 338.77c21.88 5.05 39.38 18.36 45.32 35.73l47.88 153.18.57 1.83 3.58 11.45 3.77 12.06h-28.33q-4.27-11.82-8.74-23.53c-9.18-24.05-18.83-47.84-29.34-71-5.25-11.57-10.71-23-16.38-34.1-2.72-5.32-5.48-10.59-8.3-15.71 4.75-.8 9.5-1.6 14.25-2.44l5.11-.9 1.28-.22h.09l.32-.05h-.32l-.31.05c-.67.11-1.35.18-2 .23s-1.63.1-2.45.1a30.7 30.7 0 01-13.58-3.19 30.57 30.57 0 01-12.11-10.83l-3.48-7.44a30 30 0 003.48 7.44l1 2.12.74 1.17 1 1.72 2.19 3.72c1.47 2.53 2.94 5.17 4.42 7.82.12.22.24.45.37.67l-6.24 1.06c-6.83 1.14-13.66 2.36-20.5 3.44s-13.67 2.24-20.52 3.28a39.51 39.51 0 01-6 .45 40.13 40.13 0 01-40.1-40v-.28a39.33 39.33 0 01.6-6.72c4.49-9.4 12.47-17.38 22.65-23.17a30.29 30.29 0 0026.74 31.14 30.79 30.79 0 003.57.21 30.29 30.29 0 0030-26.76 33.81 33.81 0 00.16-5.31zM1765.51 623.12l43.66 81.67a10.28 10.28 0 0018.84-8l-28.63-88.07a18.48 18.48 0 00-35.15 11.43 21.14 21.14 0 001.28 3"
          />
          <path
            className="weiterhelfen_svg__cls-69"
            d="M1760.28 652.22l35.44 61.12a10 10 0 0018.24-8l-20.9-67.5a18 18 0 10-34.41 10.66 18.72 18.72 0 001.63 3.71"
          />
          <path
            className="weiterhelfen_svg__cls-69"
            d="M1747.57 658.19l31.71 62.52a9.73 9.73 0 0018.11-6.8L1780.12 646a17.49 17.49 0 10-33.9 8.61 17.9 17.9 0 001.35 3.61"
          />
          <path
            className="weiterhelfen_svg__cls-69"
            d="M1739 666l26.87 59.36a8.87 8.87 0 0016.76-5.5l-13.51-63.74A15.94 15.94 0 101739 666"
          />
          <path
            className="weiterhelfen_svg__cls-69"
            d="M1738.72 638.28s-17.53 75-.06 77.76c14 2.25 20.59-62.1 20.59-62.1z"
          />
          <path
            className="weiterhelfen_svg__cls-67"
            d="M1233.53 570.05h.25l26.13-6.49a1 1 0 00-.5-2l-26.13 6.44a1 1 0 00.25 2M1238.57 587.85a1 1 0 00.3 0l26.28-8a1 1 0 10-.6-1.95l-26.27 8a1 1 0 00-.68 1.28 1 1 0 001 .72M1247.34 604.08a1 1 0 00.33-.05l21.92-7.34a1 1 0 00-.65-1.94l-21.94 7.34a1 1 0 00-.65 1.3 1 1 0 001 .69M1284.9 590.26a1 1 0 00.55-.16 1 1 0 00.3-1.42c-9-13.84-3.38-32.51-3.32-32.7a1 1 0 00-.12-.86 1 1 0 00-.74-.45c-12.59-1.42-24.08-8.91-24.19-9a1 1 0 00-1.13 1.71c.47.31 11.31 7.38 23.9 9.16-1.15 4.46-4.38 20.46 3.85 33.26a1 1 0 00.86.46"
          />
          <path
            className="weiterhelfen_svg__cls-68"
            d="M1545.38 473q-7.7 12-15.63 23.88c-18.69-6.48-50.78-16.65-79.52-21l.3-.44c9.59-14.31 19-29.19 28.16-44.25s18.22-30.38 27.09-45.76l6.61-11.53 3.27-5.76 1.62-2.85.37-.67.81-1.44.41-.71.48-.79c.79-1.22 1.61-2.43 2.49-3.6a49.85 49.85 0 0128.83-18.55c5.69-1.29 30.17-3.91 36-3.14 1.46.19-15.62 2.79-14.21 3.11.71.16 1.41.33 2.12.51l.58.16 1.64.44 13.07 3.53 26.12 7.18c8.69 2.46 17.39 4.88 26.06 7.42a40.06 40.06 0 01-21.21 77.26c-8.75-2.24-17.47-4.59-26.2-6.91l-18.78-5.09-1.28 2.13c-9.54 15.71-19.22 31.3-29.2 46.84m8.22-55.12h-.1.08m34.69-14.79l-.56 1 .16-.27c.14-.23.27-.46.4-.7"
          />
          <path
            className="weiterhelfen_svg__cls-68"
            d="M1580.78 337.5c6.81-1.29 13.63-2.49 20.45-3.72s13.65-2.36 20.48-3.55 13.65-2.37 20.49-3.49l5.12-.85 1.28-.21 1.51-.24c1.1-.16 2.21-.28 3.32-.38a49.85 49.85 0 0145.9 22.69 49.23 49.23 0 013.31 6l1.23 2.12c.94 1.64 1.87 3.28 2.75 4.88 1.78 3.22 3.46 6.38 5.11 9.56 3.28 6.33 6.37 12.62 9.37 18.92 6 12.6 11.61 25.2 16.94 37.85s10.39 25.35 15.23 38.08c.22.6.44 1.19.67 1.79-38.24 5-62.79 12-76.61 17q-5.41-12.84-11.13-25.48c-5.25-11.57-10.71-23-16.38-34.1-2.72-5.32-5.49-10.59-8.3-15.7l-6.24 1.05c-6.83 1.15-13.66 2.36-20.5 3.44s-13.67 2.24-20.52 3.28a40.06 40.06 0 01-13.48-79m81.7 67.57l-.28.05.28-.05m-30.71-13.6l-3.48-7.44a30 30 0 003.48 7.44"
          />
          <path
            className="weiterhelfen_svg__cls-67"
            d="M1814.16 710.37a1.06 1.06 0 00.42-.09 1 1 0 00.51-1.35l-6.09-13.54a1 1 0 00-1.87.84l6.07 13.53a1 1 0 00.93.61M1797.61 716.62a1.11 1.11 0 00.43-.09 1 1 0 00.5-1.36l-5.75-12.61a1 1 0 10-1.87.85l5.76 12.61a1 1 0 00.93.6M1782.45 725.1a1.06 1.06 0 00.42-.09 1 1 0 00.51-1.35l-6.06-13.53a1 1 0 00-1.87.83l6.06 13.53a1 1 0 00.94.61M1751.86 697.76a1 1 0 00.34-.06 1 1 0 00.63-1.31l-5.63-15.88a1 1 0 00-1.92.68l5.62 15.88a1 1 0 001 .69M1677.34 485a1 1 0 00.37-.07 1 1 0 00.58-1.33l-32.46-81.6a1 1 0 00-1.9.76l32.45 81.62a1 1 0 001 .64M1509.45 490.18l29.42-85.95a.36.36 0 00-.67-.28l-42.41 82.14z"
          />
          <path
            className="weiterhelfen_svg__cls-67"
            d="M1669.09 464.27a1 1 0 00.41-.09c24.2-10.74 74.88-18.17 75.39-18.24a1 1 0 10-.29-2c-.52.08-51.48 7.55-75.93 18.4a1 1 0 00-.51 1.35 1 1 0 00.93.61M1510.24 464.51a1 1 0 00.27-2l-43.45-11.73a1 1 0 10-.54 2l43.48 11.7h.26"
          />
          <path
            className="weiterhelfen_svg__cls-69"
            d="M1640.68 327.1s-25.9 63.88-56.16 68.07-23.39-57.17-23.39-57.17z"
          />
          <path className="weiterhelfen_svg__cls-68" d="M1539.55 287.4" />
        </g>
        <g clipPath="url(#weiterhelfen_svg__clip-path-3)">
          <path className="weiterhelfen_svg__cls-68" d="M1564.55 316.08" />
          <path
            className="weiterhelfen_svg__cls-69"
            d="M1601.69 210.63a62.79 62.79 0 0129.43 7.44 29.05 29.05 0 018.56 6.88 34.35 34.35 0 006 13.85 31 31 0 01-.19 8.63c-1.42 8.94-2.25 8.49-3.43 13.84a23.65 23.65 0 01-.71 2.59 31.42 31.42 0 01-2.37 5.29l-.19.34a55.06 55.06 0 01-10.6 12.92l-1.23-20.91a22.84 22.84 0 00-22.79-21.5h-1.36a22.84 22.84 0 00-21.33 20.12l-2.3 19.55c-.59.15-1.2.33-1.81.54l-1.1.39a1.16 1.16 0 00-.94-.66h-4.06a2.67 2.67 0 01-2.61-3.24v-.14l4.75-17.29a1.15 1.15 0 00-.8-1.41 1.54 1.54 0 00-.3 0 1.14 1.14 0 00-1.07.74v.1l-4.75 17.3a5 5 0 004.62 6.28h1.43a11 11 0 00-5.41 6.95 2.28 2.28 0 004.36 1.35c1.3-4.22 3.65-4.72 7.11-5.92l-3.52 30c-.89.23-1.78.43-2.66.61a39.71 39.71 0 01-7.63.82h-.2c-6.43 0-12.34-2-17-6.84-5.84-6.09-8-13.72-8-21.64v-.32c0-8.48 2.47-17.27 5.41-24.85 7-18 16.9-39.51 35.75-47.64l.14-.06a53.38 53.38 0 0120.84-4.1"
          />
        </g>
        <g className="weiterhelfen_svg__cls-64">
          <path
            className="weiterhelfen_svg__cls-69"
            d="M1581.48 260.18l-9.89 84.13c-1.95 16.61 9.93 16.93 26.55 18.89a30.29 30.29 0 0033.62-26.55 34 34 0 00.16-5.32l-5-69.83a22.83 22.83 0 00-45.46-1.32"
          />
          <path
            className="weiterhelfen_svg__cls-67"
            d="M1575 314.65a63.05 63.05 0 0016.54-6 1.18 1.18 0 011.46 1.8L1572.92 334zM1628.81 290.82a14.18 14.18 0 01-3.91-3.75.49.49 0 00-.89.17 18.33 18.33 0 005.44 17z"
          />
          <path
            className="weiterhelfen_svg__cls-68"
            d="M1639.13 218.57zm34.47 34.49"
          />
        </g>
        <g clipPath="url(#weiterhelfen_svg__clip-path-5)">
          <path className="weiterhelfen_svg__cls-68" d="M1673.47 253.06" />
          <path
            className="weiterhelfen_svg__cls-72"
            d="M1673.43 184.16h.25a34.45 34.45 0 01.06 68.9h-.27a34.35 34.35 0 01-27.69-14.06l-.12-.16a26.23 26.23 0 00-6-13.84 34.48 34.48 0 01-.58-6.23v-.15a34.46 34.46 0 0134.3-34.41"
          />
        </g>
        <g className="weiterhelfen_svg__cls-64">
          <path d="M1639.71 225a26.23 26.23 0 016 13.84 34.25 34.25 0 01-6-13.84" />
          <path
            className="weiterhelfen_svg__cls-72"
            d="M1701.7 256.33a25.36 25.36 0 105.5-35.45 25.37 25.37 0 00-5.5 35.45M1580.84 214.73l-.13.06c1 8.35 6.24 27.72 32.6 43.38a92.19 92.19 0 00-3.12 11.62 5.84 5.84 0 00-.33 1.93 5.73 5.73 0 0010.85 2.55l2.81-5.35a12 12 0 012.65-4.21q5.79 2.52 12.6 4.78l.19-.34a31.42 31.42 0 002.37-5.29 24.28 24.28 0 00.71-2.59c1.18-5.35 2-4.9 3.42-13.84 2-12.4-3.21-23.37-14.31-29.36-15-8.08-34.33-10.15-50.31-3.34"
          />
          <path
            className="weiterhelfen_svg__cls-69"
            d="M1621.15 277.84a17.06 17.06 0 1016-18 17.07 17.07 0 00-16 18"
          />
          <path
            className="weiterhelfen_svg__cls-67"
            d="M1632.07 279a1.11 1.11 0 00.43-.09l13.39-5.61a1.09 1.09 0 00.59-1.43 1.11 1.11 0 00-1.44-.59l-13.39 5.61a1.1 1.1 0 00.42 2.11"
          />
          <path
            className="weiterhelfen_svg__cls-67"
            d="M1640.4 281.32a1.07 1.07 0 00.39-.07 1.1 1.1 0 00.63-1.42l-1.92-5a1.1 1.1 0 10-2 .78l1.92 5a1.11 1.11 0 001 .71"
          />
          <path
            className="weiterhelfen_svg__cls-73"
            d="M1639.49 287.74s12.53 37.76 0 37.76c-11.84 0 0-37.76 0-37.76"
          />
          <path
            className="weiterhelfen_svg__cls-69"
            d="M1635.68 287.26a3.82 3.82 0 103.82-3.82 3.82 3.82 0 00-3.82 3.82"
          />
          <path
            className="weiterhelfen_svg__cls-74"
            d="M1647.17 244h.16a1.65 1.65 0 001.48-1.8 39.54 39.54 0 00-9.44-22 1.64 1.64 0 10-2.38 2.27 37 37 0 018.54 20.07 1.66 1.66 0 001.64 1.48"
          />
          <path
            className="weiterhelfen_svg__cls-68"
            d="M1536.68 262.06s5.66 7 14.86 6.67c3.9-.15 8.44-1.59 13.43-5.46a20.2 20.2 0 00-13-6.12c-4.29-.3-9.48.8-15.34 4.91"
          />
          <path
            className="weiterhelfen_svg__cls-67"
            d="M1536.68 262.06s5.66 7 14.86 6.67a9.4 9.4 0 002.17-5.69 9.56 9.56 0 00-1.69-5.89c-4.29-.3-9.48.8-15.34 4.91M1572.64 257.93a1.14 1.14 0 00-1.37.7v.1l-4.78 17.27a5 5 0 004.62 6.28h4.13a1.15 1.15 0 00.09-2.29h-4a2.67 2.67 0 01-2.62-3.24v-.14l4.75-17.29a1.15 1.15 0 00-.8-1.41M1561.13 248.35a24.6 24.6 0 00-22.11 1.83 1.15 1.15 0 00-.41 1.57 1.14 1.14 0 001.56.41 22.35 22.35 0 0120.13-1.68 21.32 21.32 0 012.37 1.1l.36.2a5 5 0 01.44.27 1.14 1.14 0 101.28-1.89l-.14-.1c-.2-.12-.48-.29-.84-.49a25.49 25.49 0 00-2.64-1.22"
          />
          <path
            className="weiterhelfen_svg__cls-68"
            d="M1576.49 262.06s5.66 7 14.86 6.67c3.9-.15 8.44-1.59 13.43-5.46a20.2 20.2 0 00-13-6.12c-4.29-.3-9.48.8-15.34 4.91"
          />
          <path
            className="weiterhelfen_svg__cls-67"
            d="M1576.49 262.06s5.66 7 14.86 6.67a9.4 9.4 0 002.17-5.69 9.56 9.56 0 00-1.69-5.89c-4.29-.3-9.48.8-15.34 4.91M1604.49 250.18a24.6 24.6 0 00-22.11-1.83 26.27 26.27 0 00-2.63 1.22l-.29.16c-.32.18-.55.33-.7.43a1.14 1.14 0 001.28 1.89l.18-.11.62-.36a21.53 21.53 0 012.38-1.1 22.33 22.33 0 0120.12 1.68 1.14 1.14 0 101.15-2M1582.4 284.64a1.13 1.13 0 00-1.41.6l-.08.2c-.05.1-.12.25-.22.43a6.23 6.23 0 01-.92 1.31 5.74 5.74 0 01-5.24 1.8 1.14 1.14 0 10-.27 2.27 8 8 0 007.2-2.53 7.9 7.9 0 001.64-2.62 1.14 1.14 0 00-.7-1.46"
          />
          <path
            className="weiterhelfen_svg__cls-69"
            d="M1579.18 279.73l-.58 4.94c-3.46 1.2-5.81 1.69-7.11 5.92a2.28 2.28 0 01-4.36-1.35 11 11 0 015.41-6.95h2.7a1.15 1.15 0 001.14-1.15 1.13 1.13 0 00-.11-.48l1.1-.39c.61-.21 1.22-.39 1.81-.54M1582.9 279.26a12.55 12.55 0 017.52 2.45 2.28 2.28 0 01.52 3.19 2.3 2.3 0 01-3.19.51 8.1 8.1 0 00-4.86-1.59 12 12 0 00-4 .76l-.28.09.58-4.94a15.8 15.8 0 013.72-.47"
          />
          <path
            className="weiterhelfen_svg__cls-67"
            d="M1576.27 280.66a1.13 1.13 0 01.11.48 1.15 1.15 0 01-1.14 1.15h-2.7a25.81 25.81 0 013.73-1.63"
          />
          <path
            className="weiterhelfen_svg__cls-75"
            d="M1549.19 279.6a19.36 19.36 0 10-18.19-12.71 19.21 19.21 0 0018.19 12.71m0-36a16.64 16.64 0 0115.6 10.91 16.63 16.63 0 11-21.31-9.89 16.39 16.39 0 015.71-1M1591.24 279.67A19.36 19.36 0 101573 267a19.29 19.29 0 0018.2 12.71m0-36a16.66 16.66 0 11-5.72 1 16.51 16.51 0 015.72-1"
          />
          <path
            className="weiterhelfen_svg__cls-75"
            d="M1608.17 256.23h.19l31.81 4.28a1.27 1.27 0 10.34-2.51l-31.81-4.28a1.27 1.27 0 00-.53 2.47M1573 258.87a1.4 1.4 0 001.07-.51 1.37 1.37 0 00-.2-1.92 6.59 6.59 0 00-7.79-.79 1.37 1.37 0 001.53 2.27 3.8 3.8 0 014.53.64 1.4 1.4 0 00.86.31"
          />
        </g>
      </g>
      <g id="weiterhelfen_svg__woman-top-left">
        <path
          className="weiterhelfen_svg__cls-63"
          d="M481.65 908V791.58c66.08-13.14 116.29-71.7 116.29-141.42V365.08c0-79.3-65-144.18-144.33-144.18H268.1c-79.38 0-144.33 64.88-144.33 144.18v285.08c0 79.3 65 144.18 144.33 144.18h129.19z"
        />
        <path
          className="weiterhelfen_svg__cls-67"
          d="M274.62 663.83l-39.21 16.29-29 12.06-15.75 6.55-61.25 25.44a7.34 7.34 0 01-9.59-4L95 660.44l-5.34-12.83-12.5-30.12-1.34-3.22a7.36 7.36 0 014-9.6l33.76-14L225 544.35a7.34 7.34 0 019.6 4l42.7 102.81 1.29 3.11a7.35 7.35 0 01-3.95 9.6"
        />
        <g className="weiterhelfen_svg__cls-76">
          <path
            className="weiterhelfen_svg__cls-77"
            d="M978.89 757.84l-340.6-235.67-71.28 86.41 296.11 289.6 115.77-140.34z"
          />
          <path
            d="M639.88 523.26q3.74 3 7.22 6.38a118.86 118.86 0 0116.82 19.92 117.36 117.36 0 016.67 11.29c1 1.94 2 3.87 2.91 5.88s1.73 4 2.55 6 1.52 4.09 2.21 6.17l1 3.12.79 2.59 1.51 5 3 10c4 13.27 8.22 26.5 12.34 39.74s8.38 26.46 12.72 39.65c8.57 26.41 14.09 39.48 23.25 65.73l6.94 19.68 7.11 19.59.3.82 113.41 110.92c-3.74-5.75.11-20 9.87-38.44a318.09 318.09 0 0127.5-42.24A234.7 234.7 0 01919 791c20.71-20.77 42.09-34 54.49-34a12.24 12.24 0 015.23 1l.17-.21zm222.69 374.38l.55.54.11-.14a7.23 7.23 0 01-.66-.4"
            fill="#2e478a"
          />
          <path
            className="weiterhelfen_svg__cls-79"
            d="M226.52 551.25a84.17 84.17 0 0085.42 84.21c27-.43 53.92-.56 80.88-.56q75.24.14 150.49 2.12c3.52.09 3.5.1 0 0q7 32.54 8.63 40.22c2.78 13.6 2.33 13.91 5 27.53q8.19 40.85 15.51 81.9l3.55 20.55 3.43 20.59q3.39 20.61 6.26 41.34l176-46q-7.63-19.49-14.77-39.11l-7.09-19.63-6.93-19.71c-9.16-26.25-14.68-39.32-23.25-65.73-4.34-13.19-8.48-26.43-12.72-39.65s-8.31-26.47-12.34-39.74l-3-10-1.51-5-.79-2.59-1-3.12c-.69-2.08-1.36-4.14-2.21-6.16s-1.67-4-2.55-6-1.91-3.94-2.91-5.88a117.36 117.36 0 00-6.67-11.29A119.4 119.4 0 00603 503c-2.05-.67-4.13-1.27-6.22-1.86l-3.13-.85c-1.05-.26-2.1-.48-3.16-.71q-3.18-.68-6.37-1.24c-2.13-.32-4.27-.58-6.42-.82a122.94 122.94 0 00-12.86-.67H561.77l-2.6.07c-55.43 1.53-110.87 1.66-166.3 1.75-52.41-.78-108.58 0-166.3 0z"
          />
          <path
            className="weiterhelfen_svg__cls-79"
            d="M585.69 869.15c2.26 8.83 17.95 12.68 40.11 11.94 16-.53 35.48-3.46 55.66-8.64a258.51 258.51 0 0044.39-15.51c23.84-11.08 38.4-23.85 35.85-33.82-2.74-10.67-24.36-15.29-53.6-12.87a249.36 249.36 0 00-40.77 7 241.74 241.74 0 00-41.53 14.65c-26.14 12.16-42.78 26.8-40.11 37.21"
          />
          <path
            d="M625.8 831.94v119.9h192.12s-4.18-25.81-59.33-60.28c-13.65-8.53-24-20.35-31.88-33.18-.28-.48-.57-1-.86-1.44-8.69-14.73-14.23-32.76-17.75-46.69a249.36 249.36 0 00-40.77 7 241.74 241.74 0 00-41.53 14.65"
            fill="#f2a696"
          />
          <path
            className="weiterhelfen_svg__cls-68"
            d="M667.33 817.73a1.11 1.11 0 01-1.06-.77l-64.5-205.71A63.27 63.27 0 00541 566.48H326.49a34.06 34.06 0 01-34-34V500.7a1.11 1.11 0 112.21 0v31.75a31.85 31.85 0 0031.81 31.82H541a65.48 65.48 0 0162.84 46.32l64.5 205.71a1.09 1.09 0 01-.72 1.38 1 1 0 01-.33.05"
          />
          <path
            className="weiterhelfen_svg__cls-79"
            d="M578.55 824.37a1.11 1.11 0 01-.86-.41 1.12 1.12 0 01.16-1.56c36-29.28 79.85-38.22 110.29-40.57 33-2.54 57.78 1.89 58 1.94a1.1 1.1 0 11-.39 2.17c-.25 0-24.83-4.43-57.52-1.9-30.11 2.33-73.47 11.17-109 40.08a1.11 1.11 0 01-.7.25"
          />
          <path
            className="weiterhelfen_svg__cls-68"
            d="M669.08 847.81a13.28 13.28 0 11-13.28-13.28 13.27 13.27 0 0113.28 13.28"
          />
          <path
            className="weiterhelfen_svg__cls-74"
            d="M226.37 505.4l3.45-167.55a61.62 61.62 0 0163.39-54.18l114.27 3.1a61.62 61.62 0 0157.63 46.86l33.4 171.77z"
          />
          <path
            className="weiterhelfen_svg__cls-68"
            d="M57 369.37zM652.1 300.38V301.26 301v-.59M57 369.06z"
          />
          <path
            className="weiterhelfen_svg__cls-81"
            d="M523.48 93.53a38.36 38.36 0 00-5.48 2.26 37.29 37.29 0 00-16.46 50.12l.27.54 6.19 12.39 6.31 12.58c4.23 8.38 8.34 16.82 12.47 25.21C535 213.46 543 230.29 550.36 247c3.7 8.34 16.56 33.67 12.58 33.95s-8.18.46-12.48.57q-5.44.14-11.09.13h-.45l2.56 12c7.57.78 14.85 1.67 21.79 2.68a2.08 2.08 0 01-.3 4.14h-.3c-6.48-.94-13.25-1.78-20.27-2.53l8.81 41.35q6 .33 11.89.7a2.08 2.08 0 01-.12 4.16h-.14q-5.31-.33-10.73-.63l4.39 20.59c4.14-.18 8.35-.42 12.68-.76 5.56-.45 11.3-1.05 17.44-2 3.07-.48 6.24-1.06 9.6-1.8s6.85-1.65 10.68-2.88c1.9-.61 3.89-1.32 6-2.15s4.27-1.79 6.59-3a71.55 71.55 0 007.34-4.26 64.07 64.07 0 008.11-6.37 58.28 58.28 0 008.19-9.46l.48-.7c.12-.17.33-.49.66-1q.86-1.37 1.62-2.76c.28-.49.46-.87.69-1.31l.62-1.28.59-1.3c.19-.43.33-.78.49-1.19a47.204 47.204 0 001.56-4.48c.45-1.49.73-2.66 1-3.95a58.47 58.47 0 001.27-11.63v-1.46c0-2.5-.18-4.62-.37-6.59a101.38 101.38 0 00-1.93-11.78c-.76-3.45-1.58-6.53-2.43-9.49-1.71-5.91-3.54-11.23-5.43-16.38s-3.86-10.06-5.89-14.88c-4-9.62-8.26-18.84-12.57-27.9-8.7-18.08-17.81-35.53-27.27-52.72-4.7-8.61-9.56-17.09-14.43-25.57l-7.44-12.66-3.8-6.3-1.15-1.88c.75 2.11 1.17 3.34 1.17 3.34l-18.63 1.12s-1.08-2.38-2.7-6.24l-14.82 5.13c0-.06-5.52-11.06-10.94-24M383.19 275.71q13.28.26 26.38.75l5.52.21-5.52-.2q-13.11-.48-26.38-.75m36.06 1.12q16.49.68 32.74 1.49c-10.84-.53-21.75-1.05-32.74-1.49m-115.5.71l-5.76.32 5.76-.33zm-9.92.56l-3 .17-10.39.63 10.39-.63 3-.17zm162.35.43l11.35.56 11.43.57-11.44-.57-11.34-.56m59.25 2.7l7.45.21-7.45-.2M170.7 289l-3.67.53 3.67-.53m-7.79 1.14c-6.7 1-13.47 2.19-20.39 3.56-5.26 1.05-10.6 2.2-16.12 3.6s-11.2 3-17.3 5.12c-3.07 1.08-6.19 2.25-9.57 3.72a104.77 104.77 0 00-10.82 5.46 74.23 74.23 0 00-13 9.58l-.91.87-.94.93-.92.94c-.3.31-.6.62-.93 1a59.52 59.52 0 00-3.8 4.64l-.93 1.29-.46.66-.67 1c-.46.73-.9 1.46-1.33 2.2s-.72 1.31-1.06 2l-.5 1-.43.9c-.27.59-.53 1.18-.78 1.78-.14.31-.25.58-.35.84l-.3.79-.59 1.59a62.18 62.18 0 00-2.52 9.83c-.48 2.74-.73 5-.92 7.21s-.27 4.13-.31 6v5.29c.13 6.7.65 12.49 1.27 18.1s1.38 10.9 2.22 16.11 1.78 10.29 2.76 15.31c2 10 4.11 19.83 6.39 29.52s4.74 19.25 7.25 28.76 5.18 18.93 7.86 28.33 5.54 18.73 8.41 28.06L97.59 550l2.29 7 2.37 7.09a37.15 37.15 0 0071.32-20.63l-.14-.57-6.69-27.24c-2.26-9.13-4.41-18.29-6.58-27.42s-4.22-18.28-6.27-27.38-4-18.18-5.8-27.21-3.57-18-5-26.8c-.75-4.4-1.42-8.76-2-13s-1.13-8.43-1.51-12.37a6.64 6.64 0 00-.43-2.08H139c-.17 0-.25-.08-.27-.16s0-.17.09-.17.18.08.29.32h.11c2.2-.65 4.6-1.28 7.08-1.89 3.78-.92 7.82-1.75 12-2.54l3.09-.56-3.66-20.92c-13.63 1-21.51 1.72-22 1.76h-.18a2.08 2.08 0 01-2.07-1.91 1.09 1.09 0 010-.18 2.08 2.08 0 011.9-2.07c.43 0 8.19-.7 21.59-1.73l-7.17-41c-13 1.23-20.52 2-21 2.08h-.26a2.09 2.09 0 01-.18-4.16c.45 0 7.9-.83 20.7-2.05l-2-11.34c5.34-1 10.6-1.88 15.82-2.69zm393 74l-1.45.06 1.45-.06m-41.74.17c2.68.06 5.38.11 8.08.15 3.89.06 7.8.09 11.75.09h.17c-4 0-8 0-11.91-.09q-4.07-.06-8.09-.15m-310.57 4.38q-9.78 1-19.37 2.21l-3.08.41 3.08-.4q9.59-1.23 19.37-2.22"
          />
          <path
            className="weiterhelfen_svg__cls-81"
            d="M148 514s61.86 48.95 53.21 58.55c-11.89 13.22-58-32.71-58-32.71z"
          />
          <path
            className="weiterhelfen_svg__cls-65"
            transform="rotate(-22.56 177.074 636.62)"
            d="M108.48 581.89H245.8v109.66H108.48z"
          />
          <path
            className="weiterhelfen_svg__cls-82"
            d="M261.58 661.02l-6.85-16.5-147.41-38.17-14.62 6.07 19.27 46.4 100.5 22.6 49.11-20.4zM122 600.25l126.12 28.36-13.49-32.46-63.29-16.39L122 600.25z"
          />
          <path
            className="weiterhelfen_svg__cls-68"
            d="M246.88 609.11a1.26 1.26 0 11.75-1.67 1.29 1.29 0 01-.75 1.67M106.61 670.29a4.3 4.3 0 01-4-2.6 4.56 4.56 0 115.85 2.23 4.7 4.7 0 01-1.82.37m.34-7.91a3.9 3.9 0 00-1.52.31 3.53 3.53 0 104.82 1.81 3.51 3.51 0 00-3.3-2.12"
          />
          <path
            className="weiterhelfen_svg__cls-81"
            d="M118.84 558.09s18.44 62.9 5.86 65.54c-11.17 2.34-24.47-67-24.47-67z"
          />
          <path
            className="weiterhelfen_svg__cls-81"
            d="M136 561.61s21.29 63.09 10 66.75-29.61-62.87-29.61-62.87z"
          />
          <path
            className="weiterhelfen_svg__cls-81"
            d="M152.22 556.87s24.32 65 13 69.2c-11 4-32.42-64.28-32.42-64.28z"
          />
          <path
            className="weiterhelfen_svg__cls-81"
            d="M161.26 537.78s32.15 72.31 21.05 76.93c-12.11 5-35.18-59.25-35.18-59.25z"
          />
          <path
            className="weiterhelfen_svg__cls-79"
            d="M165.4 597.65a1 1 0 01-1-.72l-8.54-26a1 1 0 012-.65l8.54 26a1 1 0 01-.67 1.31 1.25 1.25 0 01-.32 0M147.32 602.93a1 1 0 01-1-.77l-7.3-27a1 1 0 012-.54l7.3 27a1 1 0 01-.73 1.27 1 1 0 01-.28 0M128.59 604.15a1 1 0 01-1-.8l-5.53-22.86a1.05 1.05 0 01.77-1.26 1 1 0 011.25.77l5.53 22.86a1 1 0 01-.77 1.26h-.24"
          />
          <path
            className="weiterhelfen_svg__cls-81"
            d="M551.94 118.64S525 58.89 537.1 54.55c10.74-3.87 33.47 63 33.47 63z"
          />
        </g>
        <g clipPath="url(#weiterhelfen_svg__clip-path-8)">
          <path
            className="weiterhelfen_svg__cls-81"
            d="M516.7 52.49a3.09 3.09 0 00-1.34.3c-6.11 3 .94 23.56 8.12 40.74a36.93 36.93 0 0111.19-1.73 37.39 37.39 0 016.77.62c-1.93-5.41-3.75-11-5.12-16.27-7-12.54-14.59-23.66-19.62-23.66"
          />
        </g>
        <g className="weiterhelfen_svg__cls-76">
          <path
            className="weiterhelfen_svg__cls-81"
            d="M534.67 91.8a36.89 36.89 0 00-11.19 1.73c5.42 12.94 10.91 23.94 10.94 24l14.82-5.13c-2.07-4.91-5-12.21-7.8-20a37.39 37.39 0 00-6.77-.62"
          />
          <path
            className="weiterhelfen_svg__cls-81"
            d="M536.32 76.15c1.37 5.23 3.19 10.86 5.12 16.27 2.76 7.77 5.73 15.07 7.8 20l4.12-1.42s-8-18.61-17-34.83M519 124.46s-33-61.06-22.37-66.74c10.36-5.53 41 59.19 41 59.19z"
          />
          <path
            className="weiterhelfen_svg__cls-81"
            d="M512.73 144.62s-41.82-67.19-31.46-73.3c11.29-6.67 43 53.84 43 53.84z"
          />
          <path
            className="weiterhelfen_svg__cls-79"
            d="M512.56 112.56a1 1 0 01-.93-.58l-12.05-24.61a1 1 0 011.87-.91l12.05 24.6a1 1 0 01-.94 1.5M528.64 106a1 1 0 01-.95-.63l-11-25.73a1 1 0 011.92-.81l11 25.72a1.05 1.05 0 01-.55 1.37 1.15 1.15 0 01-.41.08M544.7 98.33a1.06 1.06 0 01-1-.66l-8.62-21.88A1 1 0 11537 75l8.63 21.89a1 1 0 01-.59 1.34 1 1 0 01-.38.08M521.48 134a1.09 1.09 0 01-.72-.28c-9.34-8.88-22.69-12.93-22.83-13a1 1 0 11.6-2c.55.16 13.15 4 22.77 12.62 2.73-3.8 13.09-16.82 28.45-18.73a1 1 0 11.26 2.06c-16.66 2.08-27.55 18.65-27.65 18.82a1.07 1.07 0 01-.76.47z"
          />
          <path
            className="weiterhelfen_svg__cls-81"
            d="M529.19 166.38s-68-40-60.79-50.66c10-14.73 61.94 24.41 61.94 24.41z"
          />
          <path
            className="weiterhelfen_svg__cls-74"
            d="M556.5 364.11l-3.54.13c-10.55.36-20.72.35-30.74.21-17.52-.26-34.58-.91-51.44-1.64-1.2-.05-4.66 2.86-8.12 5.77s-6.92 5.83-8.12 5.78c-19.19-.87-37.18-4.85-55.92-5.46s-28.67-2.61-46.83-2.32a18.3 18.3 0 01-6-1.17 17.69 17.69 0 00-6.14-1.15l-8.47 5-6.18 1.96-33.12-1.94c-18.93 1.06-31.68.88-50.34 2.33-1.67.13-3.91-1.25-6.15-2.63s-4.51-2.77-6.18-2.63c-15.24 1.25-30.33 2.68-45 4.55-7.82 1-15.51 2.15-22.89 3.46l-14.25-81.53c8.89-1.65 17.59-3 26.19-4.2 20.11-2.75 39.77-4.71 59.32-6.34s38.93-2.87 58.24-4l12.91-.73 16-.9 7.46-.39 7.66-.31c5.09-.18 10.14-.31 15.18-.37 20.16-.25 39.94.19 59.5.9s38.88 1.69 58 2.63 37.92 1.94 56.21 2.37c5.12.11 10.19.17 15.18.18z"
          />
          <path
            className="weiterhelfen_svg__cls-68"
            d="M521.2299999999999 270.51zm17.68 103"
          />
          <path
            className="weiterhelfen_svg__cls-81"
            d="M522.88 281.43h2.77l-1.91-.05h-.86M539.05 364.52h-3.33 3.33"
          />
          <path
            className="weiterhelfen_svg__cls-73"
            d="M539.32 364.52h-3.6 3.6M522.89 281.44l1.65 10.7 4.26.35-1.69-11-3.37-.06h-.85m2.3 14.93l6.49 42 4.24.17-6.46-41.84-4.27-.35m7.14 46.21l3.39 22h4.21l-3.36-21.75-4.24-.18"
          />
          <path
            className="weiterhelfen_svg__cls-81"
            d="M167 289.52l-4.12.61 4.12-.62z"
          />
          <path
            className="weiterhelfen_svg__cls-68"
            d="M179.22 371.57l-4.12.58"
          />
          <path
            className="weiterhelfen_svg__cls-74"
            d="M179.22 371.57l-4.12.58 4.12-.58"
          />
          <path
            className="weiterhelfen_svg__cls-73"
            d="M167 289.52l-4.12.62zM167 289.52l-4.12.62 1.87 12.57 4.15-.37zm2.52 16.94l-4.16.38 6.15 41.39 4.17-.3zm6.77 45.6l-4.16.3 2.94 19.79 4.12-.58zM205.46 284.8l-4.15.43zM205.46 284.8l-4.15.43 1 14.28 4.15-.33zM211.07 368l-4.15.4zM206.71 303.33l-4.15.34 2.85 42.23 4.15-.27zm3.13 46.45l-4.15.27 1.23 18.3 4.15-.4zM248.43 281.06l-4.15.31zM248.43 281.06l-4.15.32 1.1 14.91 4.15-.28zM255 370.76l-4.15.22 1.26 17.14 4.16-.1zm1.58 21.42l-4.17.09 3.59 48.29 4.16-.14zm3.85 52.4l-4.16.13 2.46 33.29 4.17-.08zm2.76 37.52l-4.17.08 1.71 23.22h4.17z"
          />
          <path
            className="weiterhelfen_svg__cls-73"
            d="M249.83 300.15l-4.15.29 3.15 42.83L253 343zm3.46 47l-4.16.23 1.74 23.62 4.15-.22z"
          />
          <path
            className="weiterhelfen_svg__cls-68"
            d="M291.27000000000004 246.92000000000002zM293.37 244.86h-.18a2.09 2.09 0 00-1.92 2v.28l2.55 31 4.16-.24-2.56-31.09a2.09 2.09 0 00-2.06-1.91"
          />
        </g>
        <g clipPath="url(#weiterhelfen_svg__clip-path-10)">
          <rect
            className="weiterhelfen_svg__cls-81"
            x={293.83}
            y={277.98}
            width={4.17}
            transform="rotate(-3.24 295.411 277.647)"
          />
          <path
            className="weiterhelfen_svg__cls-77"
            d="M316.71 505.4h-4.18l3.22 39.2a2.08 2.08 0 002.08 1.91h.17a2.07 2.07 0 001.9-2.24z"
          />
        </g>
        <g className="weiterhelfen_svg__cls-76">
          <path
            className="weiterhelfen_svg__cls-73"
            d="M297.99 277.87l-4.16.23 4.16-.23zM298 277.87l-4.16.23 1.24 15.09 4.16-.23zM301.38 369.84l1.41 17.16 4.16-.1-1.38-16.78zM307.3 391l-4.17.1 3.93 47.79 4.17-.13zm4.27 51.91l-4.17.14 2.8 34 4.17-.08zm3.14 38.22l-4.17.07 2 24.18h4.18z"
          />
          <path
            className="weiterhelfen_svg__cls-73"
            d="M299.57 297.11l-4.16.23 3.59 43.38 4.16-.18zm3.92 47.58l-4.17.18 2.06 25 4.19.24z"
          />
          <g clipPath="url(#weiterhelfen_svg__clip-path-12)">
            <path
              className="weiterhelfen_svg__cls-77"
              d="M357.54 505.4h-4.16l.69 32.42a2.08 2.08 0 002.08 2h.05a2.08 2.08 0 002-2.13z"
            />
          </g>
          <path
            className="weiterhelfen_svg__cls-73"
            d="M350.42 366.52l.41 19.34 4.16-.09-.41-19.22h-2.98a11.22 11.22 0 01-1.18-.06m4.66 23.41l-4.16.09 1 47.45 4.16-.14zm1.1 51.57l-4.16.13.74 34.65 4.16-.08zm.83 38.86l-4.16.08.53 25h4.16z"
          />
          <path
            className="weiterhelfen_svg__cls-73"
            d="M349.38 318.17l.44 20.57 4.16-.14-.43-20.15a31.52 31.52 0 01-4.14-.28m4.69 24.59l-4.16.14.51 23.62a11.22 11.22 0 001.18.06h2.98zM415.09 276.67l4.16.16-4.16-.16M415.09 276.67l-.34 12.42h4.17l.33-12.22-4.16-.16M412.57 369.89l-.39 14.57 4.17-.09.38-14c-1.39-.16-2.77-.31-4.16-.45m3.66 18.64l-4.16.1-1.27 46.94 4.17-.13zm-1.37 51.08l-4.17.13-1 35.48 4.17-.08zm-1.07 39.7l-4.17.08-.7 26h4.16zM418.81 293.21h-4.17l-1.18 44 4.16-.06zm-1.3 48.12l-4.17.05-.77 28.51c1.39.14 2.77.29 4.16.45z"
          />
        </g>
        <g clipPath="url(#weiterhelfen_svg__clip-path-13)">
          <path
            className="weiterhelfen_svg__cls-81"
            d="M452 278.32l4.19.21-4.19-.21"
          />
          <path
            className="weiterhelfen_svg__cls-77"
            d="M473.7 505.4h-4.18l2 26.1a2.08 2.08 0 002 1.93h.19"
          />
        </g>
        <g className="weiterhelfen_svg__cls-76">
          <path
            className="weiterhelfen_svg__cls-73"
            d="M452 278.32l4.19.21-4.19-.21M452 278.32l.84 10.82c1.4 0 2.78 0 4.18.06l-.83-10.67-4.19-.21M463.11 368.21l-.45.37c-1.19 1-2.38 2-3.48 2.89l.92 11.9 4.17-.1zm1.48 19.22l-4.17.09 3.58 46.34 4.16-.13zm3.9 50.45l-4.17.14 2.79 36.14 4.17-.08zm3.11 40.36l-4.17.08 2.09 27.08h4.18z"
          />
          <path
            className="weiterhelfen_svg__cls-73"
            d="M453.15 293.3l3.37 43.64h4.17l-3.36-43.59c-1.39 0-2.79-.05-4.18-.06m3.69 47.8l2.34 30.37c1.1-.88 2.29-1.88 3.48-2.89l.45-.37-2.1-27.1h-4.17"
          />
          <path
            className="weiterhelfen_svg__cls-68"
            d="M483.78 233.92zM509.65 412.61"
          />
          <path
            className="weiterhelfen_svg__cls-74"
            d="M501.26 364l4.22.12-4.22-.12"
          />
          <path
            className="weiterhelfen_svg__cls-73"
            d="M490 280.2l4.22.19-4.22-.19M490 280.2l1.34 10 4.22.19-1.34-10-4.22-.19m1.9 14.15l5.79 43 4.21.09-5.77-42.92-4.23-.19m6.35 47.2l3 22.42 4.22.12-3-22.45-4.22-.09"
          />
        </g>
        <g clipPath="url(#weiterhelfen_svg__clip-path-15)">
          <path
            className="weiterhelfen_svg__cls-81"
            d="M541.48 293.68l.92 4.28c7 .74 13.79 1.58 20.27 2.52h.3a2.08 2.08 0 00.3-4.14c-6.94-1-14.22-1.9-21.79-2.68m-392.41 10.51c-12.8 1.22-20.25 2-20.7 2.06a2.08 2.08 0 00.18 4.15h.26c.46 0 8-.85 21-2.08z"
          />
        </g>
        <g className="weiterhelfen_svg__cls-76">
          <path
            className="weiterhelfen_svg__cls-73"
            d="M432 289h-13l-.11 4.16h13.14c7.12 0 14.2 0 21.2.14l-.32-4.16Q442.48 289 432 289m-17.21.08q-15.15.14-30.43.5a30.09 30.09 0 01-.55 4.17c10.31-.24 20.63-.42 30.87-.52zM323 291.77q-12 .56-23.78 1.19l.34 4.15c8-.43 16.1-.84 24.28-1.22a30.67 30.67 0 01-.84-4.12m-27.94 1.42c-15.79.87-31.08 1.83-45.54 2.82l.3 4.14c14.49-1 29.77-1.94 45.58-2.81zm-49.69 3.1c-13.85 1-26.93 1.94-38.95 2.89l.28 4.16c12-1 25.11-1.94 39-2.9zM149.07 304.17l.72 4.11-.72-4.11zM202.28 299.51c-12.4 1-23.62 2-33.35 2.83l.62 4.12c9.64-.86 20.75-1.81 33-2.79zm-37.5 3.2c-5.86.53-11.13 1-15.71 1.46l.72 4.11c4.56-.43 9.78-.92 15.6-1.44z"
          />
          <path
            className="weiterhelfen_svg__cls-73"
            d="M168.93 302.34l-4.15.37.61 4.13 4.16-.38zM206.43 299.18l-4.15.33.28 4.16 4.15-.34zM249.53 296l-4.16.29.31 4.15 4.15-.29zM299.23 293l-4.16.23.34 4.15 4.16-.23zM457 289.2l.32 4.16c11.78.18 23.33.51 34.56 1l-.56-4.18c-11.15-.47-22.64-.79-34.32-1M418.92 289.05h-4.17l-.11 4.15h4.17z"
          />
          <path
            className="weiterhelfen_svg__cls-73"
            d="M452.83 289.14l.32 4.16c1.39 0 2.79 0 4.18.06l-.33-4.16c-1.4 0-2.78-.05-4.18-.06M495.55 290.36l.57 4.18c10 .48 19.72 1.08 29.07 1.83l-.65-4.23q-14-1.09-29-1.78m33.25 2.13l.66 4.23q6.6.57 12.94 1.23l-.92-4.27q-6.21-.65-12.68-1.19"
          />
          <path
            className="weiterhelfen_svg__cls-73"
            d="M524.54 292.14l.65 4.23 4.27.35-.66-4.23-4.26-.35M491.33 290.17l.56 4.18 4.23.19-.57-4.18-4.22-.19"
          />
        </g>
        <g clipPath="url(#weiterhelfen_svg__clip-path-17)">
          <path
            className="weiterhelfen_svg__cls-81"
            d="M551.21 339.3l.9 4.22q5.42.3 10.73.63h.16a2.08 2.08 0 00.12-4.16q-5.88-.37-11.89-.7M157 349.31c-13.4 1-21.16 1.69-21.59 1.73a2.08 2.08 0 00-1.9 2.07 1.09 1.09 0 000 .18 2.08 2.08 0 002.07 1.91h.18c.44 0 8.32-.72 22-1.76z"
          />
        </g>
        <g className="weiterhelfen_svg__cls-76">
          <path
            className="weiterhelfen_svg__cls-73"
            d="M157 349.31l.72 4.12zM452.53 336.93q-17.41 0-34.91.23l-.11 4.17q17.5-.22 35-.23h4.34l-.32-4.16h-4m8.16 0l.32 4.16c12.52 0 25 .18 37.23.44l-.56-4.18q-18.3-.36-37-.42m-47.23.27c-20 .28-40 .76-59.48 1.38l.09 4.16c19.43-.61 39.3-1.09 59.27-1.38zm88.43.24l.57 4.18c10.09.23 20.08.54 29.87.94l-.65-4.19q-14.65-.58-29.79-.93m34 1.1l.65 4.2q7.86.35 15.54.76l-.9-4.22c-5-.27-10.14-.51-15.29-.74m-186.1.18c-16 .52-31.59 1.13-46.68 1.8l.35 4.15c15-.67 30.55-1.27 46.42-1.79zm-50.84 2c-16.06.73-31.49 1.51-46 2.31l.3 4.16c14.53-.81 30-1.59 46-2.32zm-50.15 2.55c-14.07.78-27.24 1.59-39.27 2.36l.28 4.15c12-.77 25.21-1.57 39.29-2.36zm-43.42 2.63c-11 .71-21 1.4-29.7 2l.61 4.13c8.66-.62 18.52-1.3 29.37-2zm-33.87 2.33l-14.5 1.07.72 4.12 14.48-1.07z"
          />
          <path
            className="weiterhelfen_svg__cls-73"
            d="M531.68 338.39l.65 4.19 4.24.18-.65-4.2-4.24-.17M175.71 347.93l-4.17.3.62 4.13 4.16-.3zM209.56 345.63l-4.15.27.28 4.15 4.15-.27zM253 343l-4.16.24.3 4.15 4.16-.23zM303.14 340.54l-4.16.18.34 4.15 4.17-.18zM354 338.6l-4.16.14.09 4.16 4.16-.14zM417.62 337.16l-4.16.06-.12 4.16 4.17-.05zM456.52 336.94l.32 4.16H461l-.32-4.16h-4.17M497.68 337.37l.56 4.18 4.22.09-.57-4.17-4.21-.1"
          />
          <path
            className="weiterhelfen_svg__cls-68"
            d="M188.85000000000002 393.71999999999997z"
          />
          <path
            className="weiterhelfen_svg__cls-74"
            d="M474.72 383.04l.81 4.14-.81-4.14zM228.77 388.65l-.08 4.16.08-4.16z"
          />
          <path
            className="weiterhelfen_svg__cls-73"
            d="M474.72 383l-10.45.23.32 4.16 10.94-.25zm-14.62.33l-43.75 1-.11 4.16 44.18-1zm-47.92 1.09L355 385.77l.09 4.16 57-1.3zm-61.35 1.4l-43.87 1 .34 4.16 43.62-1zm-48 1.1L256.29 388l.31 4.16 46.53-1.07zm-50.66 1.16l-23.36.53-.08 4.16 23.74-.54z"
          />
          <path
            className="weiterhelfen_svg__cls-73"
            d="M256.29 388.02l-4.16.1.3 4.15 4.17-.09-.31-4.16zM306.95 386.87l-4.16.09.34 4.16 4.17-.1-.35-4.15zM354.99 385.77l-4.16.09.09 4.16 4.16-.09-.09-4.16zM416.35 384.37l-4.17.09-.11 4.17 4.17-.1.11-4.16zM464.27 383.27l-4.17.1.32 4.15 4.17-.09-.32-4.16z"
          />
          <path
            className="weiterhelfen_svg__cls-74"
            d="M484.48 433.2l.8 4.14-.8-4.14z"
          />
          <path
            className="weiterhelfen_svg__cls-73"
            d="M227.68 441.47l-.08 4.17.08-4.17zM484.47 433.2l-16.31.53.33 4.15 16.79-.54zm-20.47.66l-49 1.58-.11 4.17 49.43-1.61zm-53.2 1.71l-54.71 1.76.09 4.17 54.51-1.76zm-58.87 1.9l-40.7 1.31.34 4.15 40.45-1.3zm-44.87 1.44l-46.91 1.51.3 4.16 46.95-1.51zM256 440.56l-28.3.91-.08 4.17 28.69-.93z"
          />
          <path
            className="weiterhelfen_svg__cls-73"
            d="M260.14 440.42l-4.16.14.31 4.15 4.16-.13-.31-4.16zM311.23 438.78l-4.17.13.34 4.16 4.17-.13-.34-4.16zM356.09 437.33l-4.16.14.09 4.16 4.16-.13-.09-4.17zM414.97 435.44l-4.17.13-.11 4.17 4.17-.13.11-4.17zM468.16 433.73l-4.16.13.32 4.16 4.17-.14-.33-4.15z"
          />
          <path
            className="weiterhelfen_svg__cls-74"
            d="M492.35 473.69l-.23.01.8 4.15.23-.01-.8-4.15zM226.94 478.61h-.02l-.09 4.16h.03l.08-4.16z"
          />
          <path
            className="weiterhelfen_svg__cls-73"
            d="M492.12 473.7l-20.84.38.32 4.16 21.32-.4zm-25 .46l-53.21 1-.11 4.17 53.64-1zm-57.38 1.06l-52.81 1 .09 4.16 52.61-1zm-57 1.06l-38.39.71.34 4.15 38.14-.7zm-42.56.78l-47.3.88.31 4.16 47.33-.88zm-51.46 1l-31.8.59-.08 4.16 32.18-.59z"
          />
          <path
            className="weiterhelfen_svg__cls-73"
            d="M262.9 477.94l-4.16.08.3 4.16 4.17-.08-.31-4.16zM314.37 476.99l-4.17.07.34 4.16 4.17-.07-.34-4.16zM356.92 476.2l-4.16.08.09 4.16 4.16-.08-.09-4.16zM413.9 475.14l-4.17.08-.11 4.17 4.17-.08.11-4.17zM471.28 474.08l-4.17.08.32 4.16 4.17-.08-.32-4.16z"
          />
          <path
            className="weiterhelfen_svg__cls-81"
            d="M361.07 339.08c-45.84 0-57.32-61.54-57.32-61.54l16-.9 7.46-.39 7.66-.31c5.09-.18 10.14-.31 15.18-.38 20.16-.24 39.95.2 59.5.91 0 0-2.66 62.62-48.5 62.62"
          />
          <path
            className="weiterhelfen_svg__cls-79"
            d="M585.43 282.34H563a1 1 0 010-2.09h22.46a1 1 0 010 2.09M122.67 384.27a1 1 0 01-.23-2.06l16.65-3.87a1 1 0 01.47 2l-16.65 3.87h-.24"
          />
          <path
            className="weiterhelfen_svg__cls-81"
            d="M374.1 198.41L384.17 284a30.83 30.83 0 11-61.23 7.2 32.78 32.78 0 01-.16-5.41l5.07-86.06a23.22 23.22 0 0146.25-1.34"
          />
          <path
            className="weiterhelfen_svg__cls-79"
            d="M380.58 253.55s-5.82-.9-15.41-5.83a1.21 1.21 0 00-1.49 1.84l19 22z"
          />
          <path
            className="weiterhelfen_svg__cls-81"
            d="M351.1 147.73c-.93 0-1.86.07-2.79.13.93-.06 1.86-.11 2.79-.13m19.4 2.7l.4.15-.4-.15m-42.36 1.12a35.63 35.63 0 00-14.62 8.54 26.59 26.59 0 00-5.46 8.11 26.59 26.59 0 015.46-8.11 35.63 35.63 0 0114.62-8.54m47.26 1.06c.57.31 1.13.64 1.69 1l-1.76.9a60.38 60.38 0 0115.43 12.68 43.22 43.22 0 00-13.64-13.55c-.56-.34-1.12-.67-1.69-1m-67.27 25.48l-2.36.47v-.29V179.68a31.19 31.19 0 00.39 4.89c1.44 9.1 2.29 8.64 3.48 14.09a25.09 25.09 0 00.73 2.63c2.72 8.14 9.52 15.78 16.16 21.3l.05-.86a56.74 56.74 0 01-11.31-13.62l-.19-.35a32.4 32.4 0 01-2.41-5.37 25 25 0 01-.72-2.63c-1.19-5.45-2-5-3.48-14.08a31.75 31.75 0 01-.32-7.56"
          />
          <path
            className="weiterhelfen_svg__cls-81"
            d="M326.56 221.7l-.05.86q.8.67 1.59 1.29s16.84 15 35.82 24c-18-9-33.57-22.85-33.57-22.85-1.27-1-2.56-2.07-3.83-3.22M364 247.77l1.72.8-1.68-.83"
          />
          <path
            className="weiterhelfen_svg__cls-81"
            d="M330.88 215.49a17.36 17.36 0 11-16.32-18.34 17.35 17.35 0 0116.32 18.34"
          />
          <path
            className="weiterhelfen_svg__cls-79"
            d="M319.76 216.64a1.11 1.11 0 01-.43-.09l-13.63-5.71a1.12 1.12 0 01.87-2.06l13.63 5.71a1.12 1.12 0 01-.44 2.15"
          />
          <path
            className="weiterhelfen_svg__cls-79"
            d="M311.29 219a1.16 1.16 0 01-.4-.07 1.12 1.12 0 01-.64-1.44l2-5.13a1.11 1.11 0 012.08.8l-2 5.12a1.12 1.12 0 01-1 .72"
          />
          <path className="weiterhelfen_svg__cls-81" d="M305.77 178.6" />
        </g>
        <g clipPath="url(#weiterhelfen_svg__clip-path-19)">
          <path
            className="weiterhelfen_svg__cls-79"
            d="M352.74 147.71H351.1h1.62a60.43 60.43 0 0113.67 1.52 38.59 38.59 0 014.11 1.2 38.59 38.59 0 00-4.11-1.2 60.32 60.32 0 00-13.65-1.52m-8.52.52l-1 .13a84.31 84.31 0 00-15.05 3.19 84.31 84.31 0 0115.05-3.19l1-.13m26.68 2.35a33.22 33.22 0 014.5 2 33.22 33.22 0 00-4.5-2m-62.84 17.62a28.43 28.43 0 00-2.28 10.07 28.43 28.43 0 012.28-10.07"
          />
          <path
            className="weiterhelfen_svg__cls-79"
            d="M352.72 147.71h-1.62c-.93 0-1.86.06-2.79.13-1.36.08-2.72.21-4.09.37l-1 .13a84.31 84.31 0 00-15.05 3.19 35.63 35.63 0 00-14.62 8.54 26.59 26.59 0 00-5.46 8.11 28.43 28.43 0 00-2.28 10.07v.29l2.36-.47c.74-9.42 5.91-17.45 14.88-22.29a63.72 63.72 0 0129.93-7.56 54 54 0 0121.21 4.17l-3 .05q2.12.91 4.14 2l1.76-.91c-.56-.34-1.12-.67-1.69-1a33.22 33.22 0 00-4.5-2l-.4-.15a37.92 37.92 0 00-4.11-1.2 60.43 60.43 0 00-13.67-1.52"
          />
        </g>
        <g className="weiterhelfen_svg__cls-76">
          <path
            className="weiterhelfen_svg__cls-79"
            d="M314.69 179.69a1.29 1.29 0 101.31-1.29 1.28 1.28 0 00-1.29 1.29M317.19 188.79a1.29 1.29 0 101.29-1.29 1.28 1.28 0 00-1.29 1.29M318.46 196.12a1.29 1.29 0 101.29-1.29 1.29 1.29 0 00-1.29 1.29M312.58 185.11a1.29 1.29 0 101.29-1.29 1.29 1.29 0 00-1.29 1.29M320 183.15a1.29 1.29 0 101.29-1.29 1.29 1.29 0 00-1.29 1.29M308 181a1.29 1.29 0 101.29-1.29A1.29 1.29 0 00308 181M309.62 190.26a1.29 1.29 0 101.29-1.29 1.29 1.29 0 00-1.29 1.29M313.87 193.29a1.29 1.29 0 101.29-1.29 1.29 1.29 0 00-1.29 1.29M322 192.28a1.29 1.29 0 101.29-1.29 1.29 1.29 0 00-1.29 1.29"
          />
          <path
            className="weiterhelfen_svg__cls-90"
            d="M381.23 153.05s34.78 22.51 25.28 60.5l-34.9-57z"
          />
          <path
            className="weiterhelfen_svg__cls-79"
            d="M326.19 227.07a14.5 14.5 0 004-3.88.51.51 0 01.93.18 19.59 19.59 0 01-5.78 17.82z"
          />
          <path
            className="weiterhelfen_svg__cls-81"
            d="M382.72 254.62c-24.43-4.9-52.33-29.7-52.33-29.7-5.53-4.33-11.42-10.28-15.14-16.84l-.19-.34a32.87 32.87 0 01-2.41-5.38 25 25 0 01-.72-2.63c-1.2-5.45-2-5-3.48-14.08-2-12.61 3.27-23.76 14.56-29.85 15.2-8.21 34.9-10.32 51.14-3.4l-3 .06c19.16 8.27 32.35 30.1 39.45 48.45 5.81 15 9.72 34.68-2.67 47.59-6.62 6.9-15.68 8-25.25 6.12"
          />
          <path
            className="weiterhelfen_svg__cls-79"
            d="M378.72 253.35a63.12 63.12 0 01-16.64-6.06 1.19 1.19 0 00-1.47 1.81l19.51 17.07zM324 229.39a14.15 14.15 0 003.93-3.77.5.5 0 01.9.18 19 19 0 01-5.62 17.32zM377.49 155.74a70.84 70.84 0 01-19.65 23.87 94.83 94.83 0 01-47.48 19.82c-1.14-5.13-2-4.83-3.38-13.68-2-12.47 3.23-23.51 14.4-29.53 15-8.13 34.53-10.21 50.59-3.36l.14.06a39.3 39.3 0 015.38 2.82"
          />
          <path
            d="M314 213.67l-1.94 5.07m-5.09-8l13.47 5.64"
            stroke="#1d1d1b"
            strokeWidth={2.21}
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <path
            className="weiterhelfen_svg__cls-90"
            d="M407.67 249s-30.58 15.46-63.14-14.77c-10.95-10.16-12.32-24.12-11.85-33 1.54-29.27 48.55-48.16 48.55-48.16s-24.91-22.22-76.6-6.94c-28.27 8.35-24.73 115.84-30.89 145.2s0 46 28.81 63.29 139.75 16.68 116.82-63.29c-3.56-12.41-16.48-31.75-16.48-31.75 8.35-5.48 4.78-10.53 4.78-10.53"
          />
          <path
            className="weiterhelfen_svg__cls-79"
            d="M402.47 259.59a1 1 0 01-.18 1.46l-.21.17-.74.52c-.76.52-1.68 1.11-2.74 1.74a78.4 78.4 0 01-10.79 5.24 97.63 97.63 0 01-5.87 2.12 1 1 0 01-.64-2c2-.65 3.91-1.34 5.74-2.08a75.93 75.93 0 0010.5-5.09c1-.61 1.9-1.17 2.63-1.67l.41-.29.43-.32a1 1 0 011.46.18M274.17 295.12a1 1 0 011.46.23l.19.25c.06.09.14.19.23.3l.1.12c.45.55 1 1.17 1.62 1.83a45.25 45.25 0 006.39 5.61 42.07 42.07 0 0017.53 7.54 1 1 0 01-.36 2.05 44.08 44.08 0 01-18.39-7.91 48.38 48.38 0 01-6.69-5.87c-.66-.7-1.23-1.36-1.71-1.94l-.2-.25-.4-.52a1 1 0 01.23-1.45M287.45 185.09a1 1 0 112 .7l-.11.34-.19.58c0 .15-.08.3-.13.46a72.73 72.73 0 00-1 4 73.44 73.44 0 00-.69 24.83 76.43 76.43 0 0014.75 35.45c.47.64 1 1.27 1.45 1.91a1 1 0 11-1.63 1.28q-.76-1-1.5-2a78.82 78.82 0 01-15.14-36.4 75.79 75.79 0 01.72-25.54c.29-1.39.59-2.65.9-3.75l.11-.41c.07-.26.14-.49.21-.71l.19-.61c0-.08.05-.15.07-.19M415.12 303.48a1 1 0 111.81 1l-.06.11c0 .07-.1.15-.16.26l-.07.11q-.34.56-.84 1.29a57.31 57.31 0 01-3.51 4.54 80.55 80.55 0 01-15.21 13.72 97.78 97.78 0 01-18.15 10 1 1 0 11-.82-1.91 96.66 96.66 0 0017.77-9.84 79 79 0 0014.83-13.36 52.83 52.83 0 003.37-4.38c.26-.38.49-.73.68-1l.27-.44z"
          />
          <path
            className="weiterhelfen_svg__cls-68"
            d="M419.2 200.66s-5.76 7.12-15.13 6.78c-4-.14-8.58-1.61-13.66-5.55a20.57 20.57 0 0113.18-6.23c4.37-.31 9.64.82 15.61 5"
          />
          <path
            className="weiterhelfen_svg__cls-79"
            d="M419.2 200.66s-5.76 7.12-15.13 6.78a9.6 9.6 0 01-2.2-5.78 9.75 9.75 0 011.72-6c4.37-.31 9.64.82 15.61 5M382.61 196.46a1.15 1.15 0 011.39.71v.1l4.83 17.6a5 5 0 01-4.71 6.38H380a1.16 1.16 0 01-.1-2.32h4.1a2.73 2.73 0 002.67-3.31v-.14l-4.83-17.59a1.17 1.17 0 01.82-1.43M394.32 186.71a25 25 0 0122.5 1.86 1.17 1.17 0 01.42 1.59 1.15 1.15 0 01-1.59.42 22.71 22.71 0 00-20.48-1.7 19.82 19.82 0 00-2.42 1.11l-.36.21a4.26 4.26 0 00-.45.27 1.17 1.17 0 01-1.31-1.93l.15-.09c.2-.13.49-.3.86-.5a21.85 21.85 0 012.68-1.24"
          />
          <path
            className="weiterhelfen_svg__cls-68"
            d="M378.69 200.66s-5.76 7.12-15.13 6.78c-4-.14-8.58-1.61-13.66-5.55a20.53 20.53 0 0113.18-6.23c4.37-.31 9.64.82 15.61 5"
          />
          <path
            className="weiterhelfen_svg__cls-79"
            d="M378.69 200.66s-5.76 7.12-15.13 6.78a9.6 9.6 0 01-2.2-5.78 9.75 9.75 0 011.72-6c4.37-.31 9.64.82 15.61 5M350.19 188.57a25 25 0 0122.5-1.86 24.27 24.27 0 012.68 1.24l.3.16c.32.19.56.33.7.43a1.16 1.16 0 11-1.3 1.93l-.18-.11-.63-.37a20.55 20.55 0 00-2.42-1.11 22.71 22.71 0 00-20.48 1.7 1.16 1.16 0 01-1.17-2M372.67 223.64a1.17 1.17 0 011.44.6l.08.21c.05.1.12.25.22.44a6.74 6.74 0 00.94 1.33 5.84 5.84 0 005.33 1.83 1.18 1.18 0 011.3 1 1.16 1.16 0 01-1 1.29 8.13 8.13 0 01-7.33-2.57 8.31 8.31 0 01-1.67-2.67 1.16 1.16 0 01.71-1.48"
          />
          <path
            className="weiterhelfen_svg__cls-81"
            d="M372.17 218.16a12.82 12.82 0 00-7.66 2.49 2.33 2.33 0 001.36 4.21 2.3 2.3 0 001.36-.44 8.21 8.21 0 014.95-1.61 12.45 12.45 0 014.08.76c3.68 1.29 6.15 1.71 7.52 6.12a2.32 2.32 0 004.44-1.38 11.2 11.2 0 00-5.51-7.06H380a1.16 1.16 0 01-1.16-1.17 1.13 1.13 0 01.11-.48c-.36-.14-.74-.27-1.12-.4a17.1 17.1 0 00-5.62-1"
          />
          <path
            className="weiterhelfen_svg__cls-79"
            d="M378.91 219.59a1.13 1.13 0 00-.11.48 1.16 1.16 0 001.16 1.17h2.75a26.29 26.29 0 00-3.8-1.66M346.45 194.73h-.19l-32.37 4.35a1.28 1.28 0 01-1.45-1.1 1.3 1.3 0 011.1-1.46l32.38-4.35a1.29 1.29 0 01.53 2.52"
          />
          <path
            className="weiterhelfen_svg__cls-79"
            d="M377.48 193.39h-28.64v9.51a14.46 14.46 0 007.28 12.62 14.44 14.44 0 007 1.87 12.36 12.36 0 001.62-.1 14.42 14.42 0 0012.7-14.39zm3.1-3.87v12a18.22 18.22 0 01-17.9 18.22h-.3a18.21 18.21 0 01-18.19-18.22v-12zM421.61 193.39H393v9.51a14.59 14.59 0 008.18 13.1 14.16 14.16 0 005.73 1.37 3 3 0 00.42 0 14.32 14.32 0 0014.32-14.49zm3.87-3.1v12a18.2 18.2 0 01-17.89 18.21h-.3a18.2 18.2 0 01-18.2-18.21v-12z"
          />
          <path
            className="weiterhelfen_svg__cls-79"
            d="M341.87 189.52h3.87v3.87h-1.58a2.29 2.29 0 01-2.29-2.29zM428.58 190.29h-3.87v3.87h1.58a2.29 2.29 0 002.29-2.29zM392.44 192.61a1.29 1.29 0 01-.65-.17 14.11 14.11 0 00-13.17-.44 1.3 1.3 0 01-1.24-2.28 16.71 16.71 0 0115.71.47 1.3 1.3 0 01-.65 2.42"
          />
        </g>
        <g clipPath="url(#weiterhelfen_svg__clip-path-21)">
          <path
            className="weiterhelfen_svg__cls-77"
            d="M357.54 505.4h-4.16l.69 32.42a2.08 2.08 0 002.08 2h.05a2.08 2.08 0 002-2.13z"
          />
        </g>
        <path
          className="weiterhelfen_svg__cls-67"
          d="M173.42 565.71l28.57-11.61 17.69 5.81-42.51 17.5-3.75-11.7z"
        />
      </g>
      <g id="weiterhelfen_svg__girl-bottom">
        <path
          className="weiterhelfen_svg__cls-63"
          d="M82.8 2036.61h116.41c13.13-66.08 71.7-116.29 141.42-116.29h285.08c79.3 0 144.18 65 144.18 144.33v185.5c0 79.38-64.88 144.33-144.18 144.33H340.63c-79.3 0-144.18-64.95-144.18-144.33V2121z"
        />
        <path d="M465.12 2017.16c-9.14-12.84-27.19-18.52-42-13.22-7 2.5-13.1 7.08-19.56 10.81s-13.87 6.71-21.24 5.53c-6.28-1-11.75-4.94-16.12-9.56s-7.87-10-11.94-14.88c-7.79-9.39-17.82-17.09-29.36-21.06s-24.59-4-35.7 1.07l-23.92 90.91a63.21 63.21 0 0175.52-1c6.68 4.83 12.61 11.08 20.44 13.66s16.62 1 23.9-2.87 13.22-9.87 18.39-16.3c6.18-7.71 11.67-19.16 20-24.4 10-6.24 23.5-8.14 35.25-7.37z" />
        <path
          className="weiterhelfen_svg__cls-93"
          d="M620.76 2371.17H498.07v-92.59h109.76l6.18 26.4 6.75 66.19z"
        />
        <path
          className="weiterhelfen_svg__cls-67"
          d="M1006.61 2415.07a.91.91 0 01-.8-.48c-.07-.12-6.89-12.85-12.75-27.09-8-19.33-10.45-32.15-7.41-38.11a6.87 6.87 0 015.5-3.83 8.25 8.25 0 017 2.31c12.58 11.69 9.54 64.12 9.4 66.35a.89.89 0 01-.71.83.62.62 0 01-.19 0m-14.26-67.78a7.73 7.73 0 00-1 .07 5.09 5.09 0 00-4.13 2.86c-2.75 5.39-.17 18 7.47 36.59 4.15 10.07 8.77 19.38 11.12 24 .19-4.94.44-14.7-.06-25.07-.95-19.33-4-31.95-8.93-36.5a6.45 6.45 0 00-4.52-1.91"
        />
        <path
          className="weiterhelfen_svg__cls-93"
          d="M941 2374.9l-62.22 124.59-178.89-107.76a19.35 19.35 0 00-18.81-.65l-153.73 78.84a94.1 94.1 0 01-138.15-83.16v-113.82l131.48 5.64-11.54 72.94 87.94-45.09 38.73-19.86a126.61 126.61 0 01111.3-2.08z"
        />
        <path
          className="weiterhelfen_svg__cls-67"
          d="M890.18 2428.38a.89.89 0 01-.45-.12l-162.23-92.39a65.49 65.49 0 00-56.48-4.12l-181.91 73.4a34.79 34.79 0 01-47.21-38.69l13.6-72.36a.91.91 0 011.06-.73.92.92 0 01.73 1.06l-13.61 72.36a33 33 0 0044.75 36.67l181.92-73.4a67.33 67.33 0 0158 4.23l162.23 92.39a.91.91 0 01.34 1.24.93.93 0 01-.79.46"
        />
        <path
          className="weiterhelfen_svg__cls-67"
          d="M518.67 2337.19a.91.91 0 01-.33-1.76l83.73-31.87a.9.9 0 11.64 1.69L519 2337.13a.91.91 0 01-.32.06"
        />
        <path
          className="weiterhelfen_svg__cls-94"
          d="M711.91 2133.51c.43 2.9.65 5.78.8 8.65s.21 5.74.22 8.6-.08 5.71-.19 8.56-.3 5.69-.48 8.53c-.69 11.37-1.46 22.74-2.49 34.08s-2.28 22.67-3.61 34c-.32 2.83-.65 5.66-1 8.48s-.82 5.65-1.31 8.46-1.06 5.62-1.7 8.42-1.34 5.6-2.24 8.38a31.41 31.41 0 01-61-5.45c-.4-2.89-.59-5.77-.73-8.64s-.18-5.73-.18-8.59.09-5.71.21-8.56.31-5.69.49-8.53c.7-11.38 1.46-22.74 2.47-34.09s2.26-22.67 3.6-34c.33-2.83.66-5.66 1-8.49s.83-5.64 1.34-8.45 1.08-5.62 1.73-8.42 1.39-5.6 2.33-8.37a31.36 31.36 0 0160.74 5.42M611.6 2297.17H388.13l1.88-91 1-46.61a50.56 50.56 0 0152-44.48h1.25l89.1 2.41 3.49.09a50.6 50.6 0 0147.33 38.49l5.16 26.56z"
        />
        <path
          className="weiterhelfen_svg__cls-94"
          d="M711.75 2137.53a30.75 30.75 0 01-28.06 28h-.31c-4 .34-8.15.63-12.25.88s-8.23.52-12.34.71l-6.18.33-6.18.27q-6.16.32-12.35.52c-16.47.68-33 1-49.4 1.55q-6.67.19-13.35.42l-11.32.41c-8.21.3-16.42.59-24.63.93l-18.1.78-6.48.29-12.27.58-3.07.14c-1 .05-1.94.11-2.91.17l-5.73.35c-3.33.25-6.65.53-10 .84-12.12 1.12-24.35 2.68-36.61 4.62-11.08 1.71-22.18 3.73-33.29 5.94q-6.87 1.36-13.75 2.81-23.52 5-47 11.12l-5.28 1.4 24.21 40.94-65.01 17.47-39.17-61.09a33.32 33.32 0 0117.08-49.4l1.12-.37 6.43-2.09 6.19-1.94c4.12-1.29 8.22-2.52 12.33-3.74 8.22-2.44 16.45-4.73 24.71-7q24.78-6.68 49.91-12.23 18.29-4.05 36.86-7.32l4.81-.82c3.06-.53 6.14-1 9.22-1.51 4.35-.69 8.73-1.34 13.11-1.95h.12c12.87-1.77 25.91-3.19 39.12-4.18l6.69-.42 3.31-.2 3.15-.15 12.61-.63c4.21-.19 8.4-.36 12.61-.51s8.4-.3 12.6-.42h1.35q9.6-.32 19.21-.53c1.53 0 3.06-.09 4.6-.12 8.39-.16 16.77-.32 25.14-.41 16.76-.22 33.5-.38 50.24 0 4.19.05 8.38.18 12.57.32l6.28.19 6.27.28c4.2.18 8.38.42 12.58.66s8.36.57 12.66.94a30.72 30.72 0 0128 33.25"
        />
        <path
          className="weiterhelfen_svg__cls-95"
          d="M611.6 2297.17H388.13l1.88-91c4.32-3.12 11.2-9.44 16.92-20.94 6.62-13.29 16.29-36.07 14-66.2-.14-2-.33-4-.54-6.06q4.59-.79 9.23-1.51 6.53-1 13.1-1.95h.12c.48 2 1.06 4.28 1.45 5.63 4.42 15 15 39.93 32.57 54.42 6.07 5 13 8.17 20.76 8.17 8.29 0 14.72-4.1 19.69-10.53 10.43-13.47 12.45-32 14-49.65.51-5.69.76-10.73.88-14.59 6.41-.21 14.87-.39 21.27-.53.42 7.07 1 13.52 1.82 19.4 3.3 24.81 9.54 39.6 16.05 48.37 6.72 9.11 13.72 11.77 18 12.49z"
        />
        <path
          className="weiterhelfen_svg__cls-65"
          d="M405.34 2188.26a64.09 64.09 0 01-4.7 7.27 64.09 64.09 0 004.7-7.27z"
        />
        <path
          className="weiterhelfen_svg__cls-65"
          d="M405.34 2188.26a64.09 64.09 0 01-4.7 7.27c1.44 24 3.2 47 4.79 66l5.07-.92c-1.74-20.77-3.65-46.11-5.16-72.37M430.74 2111.3l-5.07.8c3.2 44.42 7.6 100.22 11.11 143.73l5.07-.93c-3.51-43.57-7.91-99.3-11.1-143.6"
        />
        <path className="weiterhelfen_svg__cls-95" d="M454.74 2140.89" />
        <path
          className="weiterhelfen_svg__cls-65"
          d="M454.74 2140.89c3 38.12 6.51 78.25 9.43 109.93l5.06-.93c-2.64-28.68-5.78-64.2-8.55-98.88-2.17-3.31-4.15-6.72-5.94-10.12M484.66 2174.68a31 31 0 005.31 2 31 31 0 01-5.31-2"
        />
        <path
          className="weiterhelfen_svg__cls-65"
          d="M484.66 2174.68c1.94 24.44 4.18 49.28 6.28 71.25l5.06-.93c-2-21.11-4.15-44.84-6-68.3a31.88 31.88 0 01-5.31-2"
        />
        <path
          className="weiterhelfen_svg__cls-95"
          d="M516.93 2167.65a31.27 31.27 0 01-4.72 4.82 31.27 31.27 0 004.72-4.82z"
        />
        <path
          className="weiterhelfen_svg__cls-65"
          d="M516.93 2167.65a31.27 31.27 0 01-4.72 4.82c2.17 24.42 4.23 47.82 6 68.46l5.07-.92c-1.92-21.76-4.11-46.54-6.4-72.36"
        />
        <path
          className="weiterhelfen_svg__cls-93"
          d="M558.7 2319.7l-5.07.92c0 .57.08.89.08 1l1.28-.1 3.74-1.43v-.35"
        />
        <path
          className="weiterhelfen_svg__cls-67"
          d="M558.73 2320.05l-3.74 1.43 3.83-.31c0-.08 0-.46-.09-1.12"
        />
        <path
          className="weiterhelfen_svg__cls-65"
          d="M540.36 2102.73l-5.12.2c4.23 47 8.26 94.28 11.47 132.8l5.07-.92c-3.2-38.36-7.2-85.35-11.42-132.08"
        />
        <path
          className="weiterhelfen_svg__cls-95"
          d="M568.41 2165.8c.34.58.68 1.13 1 1.67-.35-.54-.69-1.09-1-1.67"
        />
        <path
          className="weiterhelfen_svg__cls-93"
          d="M588.75 2314.2l-5 .93c.25 2.34.39 3.64.41 3.78l5.1-.44c0-.15-.17-1.62-.46-4.27"
        />
        <path
          className="weiterhelfen_svg__cls-65"
          d="M571.33 2170.2a43.6 43.6 0 003 3.66 43.6 43.6 0 01-3-3.66M569.44 2167.47q.93 1.46 1.89 2.73-1-1.27-1.89-2.73"
        />
        <path
          className="weiterhelfen_svg__cls-65"
          d="M568.41 2165.8c2.22 23.13 4.41 45.09 6.41 64.79l5.06-.92c-1.74-17.14-3.62-36-5.54-55.81a43.08 43.08 0 01-3-3.65 52.24 52.24 0 01-1.89-2.74c-.35-.54-.69-1.09-1-1.67"
        />
        <path
          className="weiterhelfen_svg__cls-67"
          d="M656.89 2168.45h-18.44a.86.86 0 010-1.71h18.44a.86.86 0 110 1.71M345.09 2210a.86.86 0 01-.73-.41l-9.36-15.35a.85.85 0 011.46-.89l9.36 15.34a.85.85 0 01-.29 1.17.8.8 0 01-.44.13"
        />
        <path
          className="weiterhelfen_svg__cls-96"
          transform="rotate(-10.36 518.605 2283.54)"
          d="M268.07 2241.55h501.25v84.75H268.07z"
        />
        <path
          className="weiterhelfen_svg__cls-97"
          d="M757.64 2197.18l15.2 83.38 39.69-34.41 19.34-16.77a3 3 0 001-2.24 3 3 0 01-1 2.24l-19.34 16.77a23.38 23.38 0 01-8.67-14.33 24.16 24.16 0 01-.39-4.21v-.07a23.43 23.43 0 013.45-12.17l-49.28-18.19"
        />
        <path
          className="weiterhelfen_svg__cls-97"
          d="M757.64 2197.18c-12.11 50.8 14.92 83.05 15.2 83.37l-15.2-83.36"
        />
        <path
          className="weiterhelfen_svg__cls-68"
          d="M227.73 2307.62zm25.71 67.59"
        />
        <path
          className="weiterhelfen_svg__cls-97"
          d="M264.56 2287.3l-23.39 4.27a16.39 16.39 0 00-13.44 16v.18a17.73 17.73 0 00.27 2.87l9.33 51.15a16.37 16.37 0 0016.07 13.44 16.41 16.41 0 002.94-.27l23.38-4.26-7.6-41.69-7.6-41.69"
        />
        <path
          className="weiterhelfen_svg__cls-67"
          d="M267.24 2302.89a.86.86 0 01-.15-1.7l487.62-89.13a.86.86 0 011 .69.85.85 0 01-.69 1l-487.62 89.12zM277.22 2357.61a.85.85 0 01-.16-1.69l487.63-89.13a.84.84 0 011 .68.85.85 0 01-.68 1l-487.64 89.13zM270.57 2321.13a.85.85 0 01-.16-1.69L754.26 2231a.85.85 0 11.3 1.68l-483.84 88.45zM273.89 2339.37a.86.86 0 01-.84-.7.85.85 0 01.69-1l483.84-88.45a.86.86 0 11.31 1.69l-483.84 88.44z"
        />
        <path
          className="weiterhelfen_svg__cls-97"
          d="M803.47 2227.54zm9.06 18.61"
        />
        <path
          d="M806.92 2215.37a23.43 23.43 0 00-3.45 12.17v.07a24.16 24.16 0 00.39 4.21 23.38 23.38 0 008.67 14.33l19.34-16.77a3 3 0 001-2.24v-.1a3 3 0 00-2-2.82z"
          fill="#947338"
        />
        <path
          className="weiterhelfen_svg__cls-67"
          d="M271.49 2372.78a.86.86 0 01-.84-.7l-15.06-82.62a.85.85 0 011.68-.31l15.06 82.62a.85.85 0 01-.68 1z"
        />
        <path
          className="weiterhelfen_svg__cls-94"
          d="M618 2207.15c15.28-.34 13.54 41.24 6 42.36-8.85 1.32-22.66-42-6-42.36"
        />
        <path
          className="weiterhelfen_svg__cls-94"
          d="M603.23 2208.73c15.28-.35 13.55 41.23 6 42.36-8.86 1.31-22.66-42-6-42.36M632.77 2205.46c15.28-.35 11.68 41.63 6 42.36-9 1.14-22.65-42-6-42.36"
        />
        <path
          className="weiterhelfen_svg__cls-67"
          d="M629.69 2238.7a.85.85 0 01-.81-.58c-2.45-7.14-6.29-22.25-3.25-28.33a.85.85 0 111.53.76c-2.58 5.17.58 19 3.33 27a.84.84 0 01-.53 1.08.86.86 0 01-.27 0M614.46 2240.71a.86.86 0 01-.81-.57c-2.45-7.14-6.28-22.26-3.25-28.34a.86.86 0 011.15-.38.85.85 0 01.38 1.14c-2.58 5.18.58 19 3.34 27a.87.87 0 01-.53 1.09.9.9 0 01-.28 0"
        />
        <path
          className="weiterhelfen_svg__cls-94"
          d="M648.57 2206.22c15.28-.34 13.83 41.17 6 42.36s-22.65-42-6-42.36"
        />
        <path
          className="weiterhelfen_svg__cls-67"
          d="M643.89 2235.67a.86.86 0 01-.81-.59c-1.25-3.71-5-16.4-1.45-23.59a.86.86 0 111.53.77c-2.62 5.24-.92 14.94 1.54 22.28a.87.87 0 01-.81 1.13"
        />
        <path
          className="weiterhelfen_svg__cls-94"
          d="M358.41 2349.91a30.49 30.49 0 0054.39-26.7 29.69 29.69 0 00-2.47-5.28l-29.27-49.49-15.91-26.92-65.06 17.48z"
        />
        <path
          className="weiterhelfen_svg__cls-99"
          d="M354.81 2286.06l30.35 73.83a8.87 8.87 0 01-15.68 8.13l-42.84-67.35a15.93 15.93 0 0126.88-17.1 16.36 16.36 0 011.29 2.49"
        />
        <path
          className="weiterhelfen_svg__cls-99"
          d="M377 2298.54l21.19 57.1a8.63 8.63 0 01-15.31 7.74l-33.42-50.92a15.52 15.52 0 1126-17 16.55 16.55 0 011.58 3.11"
        />
        <path
          className="weiterhelfen_svg__cls-99"
          d="M388 2293.37l24.17 55.38a8.38 8.38 0 01-14.45 8.31L362 2308.31a15.08 15.08 0 1124.33-17.81 15.88 15.88 0 011.65 2.87"
        />
        <path
          className="weiterhelfen_svg__cls-99"
          d="M397.9 2291.94l24.72 50.44a7.64 7.64 0 01-12.85 8.12l-35-43.95a13.74 13.74 0 1121.51-17.11 14.37 14.37 0 011.58 2.5"
        />
        <g
          clipPath="url(#weiterhelfen_svg__clip-path-22)"
          mask="url(#weiterhelfen_svg__mask)"
        >
          <path
            className="weiterhelfen_svg__cls-94"
            d="M379.59 2276.56s59.41 29.44 51.73 42.62c-6.18 10.55-52.58-20.37-52.58-20.37z"
          />
        </g>
        <path
          className="weiterhelfen_svg__cls-67"
          d="M398.69 2359a.89.89 0 01-.8-.5l-5.22-10.74a.88.88 0 111.58-.77l5.23 10.74a.88.88 0 01-.41 1.18.85.85 0 01-.38.09M412.64 2353.59a.89.89 0 01-.79-.49l-5.67-11.46a.88.88 0 011.58-.78l5.67 11.46a.88.88 0 01-.4 1.18.89.89 0 01-.39.09M411.24 2318.26a.88.88 0 01-.75-.43l-7.49-12.45a.89.89 0 011.52-.91l7.47 12.45a.89.89 0 01-.3 1.21 1 1 0 01-.46.13"
        />
        <path
          className="weiterhelfen_svg__cls-94"
          d="M492.52 2008.65a51.91 51.91 0 00-24.38 6.16c-9.2 5-13.48 14-11.86 24.31 1.16 7.28 1.85 7 2.79 11.26 0 .07 0 .13.05.2a18.54 18.54 0 00.59 2.15 26.14 26.14 0 002 4.38l.15.28a45.87 45.87 0 008.89 10.8l1-17.71a19.08 19.08 0 0119-18h1.14a19.06 19.06 0 0114.55 8.17 22.78 22.78 0 013.81 1.55 1 1 0 01-.46 1.87.93.93 0 01-.45-.11q-.67-.35-1.35-.63a18.62 18.62 0 011.72 6l1.94 16.5c.37.1.74.22 1.12.35l1.14.41a1 1 0 011-.78h3.2a2.11 2.11 0 001.67-.84 2.07 2.07 0 00.34-1.83l-3.92-14a1 1 0 01.68-1.22.84.84 0 01.27 0 1 1 0 011 .72l3.93 14a4 4 0 01-.67 3.56 4.06 4.06 0 01-3.24 1.63h-1.44a9.2 9.2 0 014.68 5.89 1.9 1.9 0 01-1.25 2.39 1.87 1.87 0 01-.57.08 1.9 1.9 0 01-1.82-1.34c-.9-2.91-2.39-3.7-4.51-4.45a1.33 1.33 0 01.07.45v2.37a3.07 3.07 0 01-.3 1.35 3 3 0 01-.22.39l2.35 20c.56.14 1.12.27 1.68.38a33.07 33.07 0 006.31.68h.17a18.83 18.83 0 0014.09-5.67c4.84-5.05 6.63-11.38 6.64-18v-.2a56.31 56.31 0 00-3.64-18.37 14.85 14.85 0 01-8.63 2.92h-.14c-3.14 0-6.83-1-10.94-4a16.34 16.34 0 0110.29-5.34 14.85 14.85 0 011.66-.09 17.16 17.16 0 015.62 1c-5.11-12.66-12.12-26.56-23.87-33.82a32.18 32.18 0 00-4.43-2.33h-.11a44 44 0 00-17.27-3.4"
        />
        <path
          className="weiterhelfen_svg__cls-94"
          d="M509.73 2049.38l8.27 70.3a25.31 25.31 0 01-50.28 5.91 27.68 27.68 0 01-.13-4.45l4.16-70.66a19.07 19.07 0 0138-1.1"
        />
        <path
          className="weiterhelfen_svg__cls-67"
          d="M515.07 2094.78a52.2 52.2 0 01-13.69-5 1 1 0 00-1.21 1.5l16.66 19.53zM470.33 2075.05a11.52 11.52 0 003.23-3.11.42.42 0 01.75.15 15.67 15.67 0 01-4.63 14.26z"
        />
        <path d="M509.79 2012.05h.11a32.77 32.77 0 014.43 2.33 58.53 58.53 0 01-16.18 19.65 76.63 76.63 0 01-16.67 10.11 83 83 0 013.88 13.28 4.79 4.79 0 01-8.79 3.75l-2.35-4.47c-1.57-4.44-7.39-6.49-9.71-7.22-1.8.35-3.62.64-5.44.86-.94-4.22-1.63-4-2.79-11.26-1.62-10.27 2.66-19.35 11.86-24.31 12.38-6.69 28.42-8.41 41.65-2.76" />
        <path
          className="weiterhelfen_svg__cls-94"
          d="M476.42 2064.3a14.12 14.12 0 11-13.28-14.92 14.13 14.13 0 0113.28 14.92"
        />
        <path
          className="weiterhelfen_svg__cls-67"
          d="M467.37 2065.24a.93.93 0 01-.35-.08l-11.09-4.64a.9.9 0 01-.48-1.19.91.91 0 011.19-.49l11.08 4.65a.91.91 0 01-.35 1.75"
        />
        <path
          className="weiterhelfen_svg__cls-67"
          d="M460.48 2067.18a.7.7 0 01-.32-.06.9.9 0 01-.53-1.17l1.59-4.17a.91.91 0 011.18-.52.9.9 0 01.52 1.17l-1.59 4.17a.91.91 0 01-.85.58"
        />
        <path
          className="weiterhelfen_svg__cls-73"
          d="M456 2029.09a1.8 1.8 0 01-.5-.08 1.68 1.68 0 01-1.11-2.11 25.26 25.26 0 018.71-11.9 1.69 1.69 0 112 2.75 22.22 22.22 0 00-7.45 10.15 1.71 1.71 0 01-1.62 1.19"
        />
        <path
          className="weiterhelfen_svg__cls-68"
          d="M512.47 2052.75s-4.37 5.83-11.82 5.85c-3.15 0-6.87-1-11-4a16.37 16.37 0 0110.29-5.34c3.46-.38 7.69.36 12.56 3.5"
        />
        <path
          className="weiterhelfen_svg__cls-67"
          d="M512.47 2052.75s-4.37 5.83-11.82 5.85a7.81 7.81 0 01-.74-9.35c3.46-.38 7.69.36 12.56 3.5"
        />
        <path
          className="weiterhelfen_svg__cls-68"
          d="M530.92 2047.35a16.32 16.32 0 00-10.29 5.35c4.11 3 7.8 4 10.94 4h.08a7.82 7.82 0 01-.73-9.35"
        />
        <path className="weiterhelfen_svg__cls-99" d="M531.71 2056.7" />
        <path
          className="weiterhelfen_svg__cls-67"
          d="M538.2 2048.24c.45 1.11.89 2.22 1.31 3.31.28.73.56 1.47.83 2.23a15.56 15.56 0 003.13-2.93 24.47 24.47 0 00-5.27-2.61"
        />
        <path
          className="weiterhelfen_svg__cls-67"
          d="M532.69 2047.26h-.23a15.36 15.36 0 00-1.54.09 7.82 7.82 0 00.73 9.35h.06a14.85 14.85 0 008.63-2.92c-.27-.76-.55-1.5-.83-2.23-.43-1.09-.86-2.2-1.31-3.31a17.21 17.21 0 00-5.51-1M514.9 2067.83a1 1 0 010-2h3.2a2.11 2.11 0 001.67-.84 2.07 2.07 0 00.34-1.83l-3.92-14a1 1 0 111.9-.54l3.93 14a4 4 0 01-.67 3.56 4.06 4.06 0 01-3.24 1.63z"
        />
        <path className="weiterhelfen_svg__cls-99" d="M489 2044.11z" />
        <path d="M506.46 2040.73a18.69 18.69 0 011.55 2.68q.67.28 1.35.63a.93.93 0 00.45.11 1 1 0 00.46-1.87 22.78 22.78 0 00-3.81-1.55" />
        <path d="M500.75 2039.86h-.2a20 20 0 00-11.15 3.47 1 1 0 00-.39.78 1 1 0 00.2.58 1 1 0 001.38.2 18.24 18.24 0 0117.42-1.5 18.69 18.69 0 00-1.55-2.68 19.45 19.45 0 00-5.71-.87M522.36 2043.47a1 1 0 01-.82-.43 1 1 0 01.26-1.38 20.11 20.11 0 0120.89-.11 1 1 0 01-1 1.72 18.14 18.14 0 00-18.79 0 1 1 0 01-.55.17" />
        <path
          className="weiterhelfen_svg__cls-67"
          d="M513.26 2070.84v2.37a3.07 3.07 0 01-.3 1.35 3.18 3.18 0 01-6.06-1.35v-2.37a1.35 1.35 0 011.34-1.35h3.68a1.35 1.35 0 011.34 1.35"
        />
        <path
          className="weiterhelfen_svg__cls-99"
          d="M506.9 2072.72zm3.22 3.67"
        />
        <path
          className="weiterhelfen_svg__cls-102"
          d="M506.9 2072.72v.52a3.18 3.18 0 003.13 3.15 3.18 3.18 0 01-3.14-3.18zm4.17 3.51a3 3 0 01-.95.16 3.25 3.25 0 00.94-.16"
        />
        <path
          className="weiterhelfen_svg__cls-102"
          d="M508.81 2072.35h-.09a5.05 5.05 0 00-1.82.37v.49a3.18 3.18 0 003.14 3.18h.08a3 3 0 00.95-.16 3.16 3.16 0 001.89-1.67 5.11 5.11 0 00-4.15-2.21"
        />
        <path
          className="weiterhelfen_svg__cls-94"
          d="M511.67 2065.87l.43 3.64a1.33 1.33 0 011.09.88c2.12.75 3.61 1.54 4.51 4.45a1.9 1.9 0 001.82 1.34 1.87 1.87 0 00.57-.08 1.9 1.9 0 001.25-2.39 9.2 9.2 0 00-4.68-5.89h-1.76a1 1 0 01-1-1 .75.75 0 010-.21l-1.14-.41c-.38-.13-.75-.25-1.12-.35"
        />
        <path
          className="weiterhelfen_svg__cls-94"
          d="M508.17 2065.38a10.48 10.48 0 00-6.29 2 1.91 1.91 0 001.12 3.45 1.86 1.86 0 001.11-.36 6.76 6.76 0 014.07-1.32 9.33 9.33 0 012.27.3h1.65l-.43-3.64a13.24 13.24 0 00-3.5-.49"
        />
        <path
          className="weiterhelfen_svg__cls-67"
          d="M513.93 2066.63a.75.75 0 000 .21 1 1 0 001 1h1.76a23.08 23.08 0 00-2.73-1.19M511.92 2069.49h-1.47q.53.14 1.08.33l1.66.57a1.33 1.33 0 00-1.09-.88h-.18"
        />
        <path
          className="weiterhelfen_svg__cls-99"
          d="M400.64 2195.53a64.09 64.09 0 004.7-7.27l-.15-2.67"
        />
        <g clipPath="url(#weiterhelfen_svg__clip-path-23)">
          <path
            className="weiterhelfen_svg__cls-93"
            d="M620.76 2371.17H498.07v-92.59h109.76l6.18 26.4 6.75 66.19z"
          />
          <path
            className="weiterhelfen_svg__cls-93"
            d="M941 2374.9l-62.22 124.59-178.89-107.76a19.35 19.35 0 00-18.81-.65l-153.73 78.84a94.1 94.1 0 01-138.15-83.16v-113.82l131.48 5.64-11.54 72.94 87.94-45.09 38.73-19.86a126.61 126.61 0 01111.3-2.08z"
          />
          <path
            className="weiterhelfen_svg__cls-67"
            d="M890.18 2428.38a.89.89 0 01-.45-.12l-162.23-92.39a65.49 65.49 0 00-56.48-4.12l-181.91 73.4a34.79 34.79 0 01-47.21-38.69l13.6-72.36a.91.91 0 011.79.33l-13.61 72.36a33 33 0 0044.75 36.67l181.92-73.4a67.33 67.33 0 0158 4.23l162.23 92.39a.91.91 0 01.34 1.24.93.93 0 01-.79.46"
          />
          <path
            className="weiterhelfen_svg__cls-67"
            d="M518.67 2337.19a.91.91 0 01-.33-1.76l83.73-31.87a.9.9 0 11.64 1.69L519 2337.13a.91.91 0 01-.32.06"
          />
          <path
            className="weiterhelfen_svg__cls-99"
            d="M611.6 2297.17H388.13l1.88-91 1-46.61a50.56 50.56 0 0152-44.48h1.25l89.1 2.41 3.49.09a50.6 50.6 0 0147.33 38.49l5.16 26.56z"
          />
          <path
            className="weiterhelfen_svg__cls-99"
            d="M711.75 2137.54a30.75 30.75 0 01-28.06 28h-.31c-4 .34-8.15.63-12.25.88s-8.23.52-12.34.71l-6.18.34-6.18.26q-6.16.32-12.35.52c-16.47.68-33 1-49.4 1.55q-6.67.19-13.35.43l-11.32.41c-8.21.29-16.42.58-24.63.92l-18.1.79-6.48.28-12.27.58-3.07.14c-1 .05-1.94.12-2.91.17l-5.73.35c-3.33.25-6.65.53-10 .84-12.12 1.12-24.35 2.68-36.61 4.62-11.08 1.71-22.18 3.73-33.29 5.94q-6.87 1.36-13.75 2.81-23.52 5-47 11.12l-5.28 1.4 24.21 40.94-65.01 17.46-39.17-61.09a33.27 33.27 0 0110.05-46 32.59 32.59 0 017-3.42l1.12-.38 6.43-2.09 6.19-1.94c4.12-1.29 8.22-2.52 12.33-3.74 8.22-2.43 16.45-4.72 24.71-7q24.78-6.69 49.91-12.24 18.29-4.05 36.86-7.32l4.81-.82c3.06-.53 6.14-1 9.22-1.51 4.35-.69 8.73-1.34 13.11-1.95h.12c12.87-1.77 25.91-3.19 39.12-4.18l6.69-.42 3.31-.2 3.15-.15 12.61-.63c4.21-.19 8.4-.36 12.61-.51s8.4-.3 12.6-.42h1.35q9.6-.32 19.21-.53c1.53 0 3.06-.09 4.6-.12 8.39-.16 16.77-.32 25.14-.41 16.76-.22 33.5-.38 50.24 0 4.19.05 8.38.18 12.57.32l6.28.19 6.27.28c4.2.18 8.38.42 12.58.66s8.36.57 12.66.94a30.73 30.73 0 0128 33.26"
          />
          <path
            className="weiterhelfen_svg__cls-95"
            d="M611.6 2297.17H388.13l1.88-91c4.32-3.12 11.2-9.44 16.92-20.94 6.62-13.29 16.29-36.07 14-66.2-.14-2-.33-4-.54-6.06q4.59-.79 9.23-1.51c4.34-.69 8.72-1.34 13.1-1.95h.12c.48 2 1.06 4.28 1.45 5.63 4.42 15 15 39.93 32.57 54.42 6.07 5 13 8.17 20.76 8.17 8.29 0 14.72-4.1 19.69-10.53 10.43-13.47 12.45-32 14-49.65.51-5.69.76-10.73.88-14.59 6.41-.21 14.87-.39 21.27-.53.42 7.07 1 13.52 1.82 19.4 3.3 24.81 9.54 39.6 16.05 48.38 6.72 9.11 13.72 11.76 18 12.48z"
          />
          <path
            className="weiterhelfen_svg__cls-65"
            d="M405.34 2188.26a64.09 64.09 0 01-4.7 7.27c1.44 24 3.2 47 4.79 66l5.07-.92c-1.74-20.77-3.65-46.11-5.16-72.37M430.74 2111.3l-5.07.8c3.2 44.42 7.6 100.22 11.11 143.73l5.07-.93c-3.51-43.57-7.91-99.3-11.1-143.6M454.74 2140.89c3 38.12 6.51 78.25 9.43 109.93l5.06-.93c-2.64-28.67-5.78-64.2-8.55-98.88-2.17-3.31-4.15-6.72-5.94-10.12M484.66 2174.68c1.94 24.44 4.18 49.28 6.28 71.25l5.06-.93c-2-21.11-4.15-44.84-6-68.3a31.88 31.88 0 01-5.31-2M516.93 2167.65a31.27 31.27 0 01-4.72 4.82c2.17 24.43 4.23 47.83 6 68.46l5.07-.92c-1.92-21.76-4.11-46.54-6.4-72.36"
          />
          <path
            className="weiterhelfen_svg__cls-93"
            d="M558.7 2319.7l-5.07.92c0 .57.08.89.08 1l1.28-.1 3.74-1.43v-.35"
          />
          <path
            className="weiterhelfen_svg__cls-65"
            d="M540.36 2102.73l-5.12.2c4.23 47 8.26 94.28 11.47 132.8l5.07-.92c-3.2-38.36-7.2-85.35-11.42-132.08"
          />
          <path
            className="weiterhelfen_svg__cls-96"
            transform="rotate(-10.36 518.605 2283.54)"
            d="M268.07 2241.56h501.25v84.75H268.07z"
          />
          <path
            className="weiterhelfen_svg__cls-68"
            d="M227.73 2307.62zm25.71 67.59"
          />
          <path
            className="weiterhelfen_svg__cls-97"
            d="M264.56 2287.31l-23.39 4.26a16.39 16.39 0 00-13.44 16v.18a17.62 17.62 0 00.27 2.87l9.33 51.15a16.37 16.37 0 0016.07 13.44 16.41 16.41 0 002.94-.27l23.38-4.26-7.6-41.69-7.6-41.68"
          />
          <path
            className="weiterhelfen_svg__cls-67"
            d="M267.24 2302.89a.86.86 0 01-.15-1.7l487.62-89.13a.87.87 0 011 .69.85.85 0 01-.69 1l-487.62 89.13zM277.22 2357.61a.85.85 0 01-.16-1.69l487.63-89.13a.84.84 0 011 .68.85.85 0 01-.68 1l-487.64 89.13zM270.57 2321.13a.85.85 0 01-.16-1.69L754.26 2231a.86.86 0 01.3 1.69l-483.84 88.44zM273.89 2339.37a.86.86 0 01-.84-.7.85.85 0 01.69-1l483.84-88.44a.85.85 0 011 .68.87.87 0 01-.69 1l-483.84 88.44zM271.49 2372.78a.86.86 0 01-.84-.7l-15.06-82.62a.85.85 0 011.68-.31l15.06 82.63a.85.85 0 01-.68 1z"
          />
          <path
            className="weiterhelfen_svg__cls-94"
            d="M358.41 2349.91a30.49 30.49 0 0054.39-26.7 29.69 29.69 0 00-2.47-5.28l-29.27-49.49-15.91-26.92-65.06 17.48z"
          />
          <path
            className="weiterhelfen_svg__cls-94"
            d="M354.81 2286.06l30.35 73.83a8.87 8.87 0 01-15.68 8.13l-42.84-67.35a15.93 15.93 0 0126.88-17.1 16.36 16.36 0 011.29 2.49"
          />
          <path
            className="weiterhelfen_svg__cls-94"
            d="M377 2298.54l21.19 57.1a8.63 8.63 0 01-15.31 7.75l-33.42-50.93a15.52 15.52 0 0126-17 16.55 16.55 0 011.58 3.11"
          />
          <path
            className="weiterhelfen_svg__cls-94"
            d="M388 2293.37l24.17 55.38a8.38 8.38 0 01-14.45 8.31L362 2308.31a15.08 15.08 0 1124.33-17.81 15.88 15.88 0 011.65 2.87"
          />
          <path
            className="weiterhelfen_svg__cls-94"
            d="M397.9 2291.94l24.72 50.44a7.64 7.64 0 01-12.85 8.12l-35-43.95a13.74 13.74 0 1121.51-17.11 14.37 14.37 0 011.58 2.5"
          />
          <path
            className="weiterhelfen_svg__cls-94"
            d="M379.59 2276.57s59.41 29.43 51.73 42.61c-6.18 10.55-52.58-20.37-52.58-20.37z"
          />
          <path
            className="weiterhelfen_svg__cls-67"
            d="M398.69 2359a.89.89 0 01-.8-.5l-5.22-10.74a.88.88 0 111.58-.77l5.23 10.74a.88.88 0 01-.41 1.18.85.85 0 01-.38.09M412.64 2353.59a.89.89 0 01-.79-.49l-5.67-11.46a.88.88 0 011.58-.78l5.67 11.46a.88.88 0 01-.4 1.18.89.89 0 01-.39.09M411.24 2318.26a.88.88 0 01-.75-.43l-7.49-12.45a.89.89 0 011.52-.91l7.47 12.45a.89.89 0 01-.3 1.21 1 1 0 01-.46.13"
          />
        </g>
        <g id="weiterhelfen_svg__armband">
          <path
            className="weiterhelfen_svg__cls-104"
            d="M313.4 2282.18a7.15 7.15 0 10-7.15-7.15 7.15 7.15 0 007.15 7.15M327 2275.25a7.14 7.14 0 10-7.15-7.14 7.14 7.14 0 007.15 7.14M340.86 2267.22a7.15 7.15 0 10-7.15-7.15 7.15 7.15 0 007.15 7.15M355.82 2260.52a7.15 7.15 0 10-7.15-7.14 7.14 7.14 0 007.15 7.14M369.88 2254.2a7.15 7.15 0 10-7.14-7.15 7.14 7.14 0 007.14 7.15"
          />
          <path
            stroke="#ff0001"
            strokeMiterlimit={10}
            strokeWidth={3.15}
            fill="none"
            d="M371.22 2246.24l-58.05 29.24"
          />
        </g>
      </g>
    </svg>
  );
});

export default SvgWeiterhelfen;

